import { useState, useRef } from 'react';
import { css } from '@emotion/react';
import { motion, AnimatePresence } from 'framer-motion';

const imgShape = '/assets/7c611288b3b18833022cd86354fe2d129fb5c9d5.svg';
const imgImage = '/assets/2b0b8d33adf3993f9117c0d28a96a594f3ddf53d.png';
const imgImage1 = '/assets/ab942af206854520d706d2e68f97e755796e4361.png';
const imgImage2 = '/assets/56e4ad770529f895a9d4d49c785a23ee765f40e9.png';
const imgShape1 = '/assets/bb4530517f1c58b1373ff7f02bf99e8146611809.svg';
const imgShape3 = '/assets/23ba194a6421630962a8e678013685a05dac6546.svg';
const imgSeparator = '/assets/d56368f91ca45a614721cbbc5ec9b276df0dcf08.svg';
const imgBumpOffer = '/assets/d903cfba03bb9a69a72b7a388fb1fac0d9d58586.png';
const imgProfilePic = '/assets/800be0d2bdc58283b97a7470827da87f784e2e94.png';

// ─── reset styles applied to this page ───────────────────────────────────────
const pageReset = css`
  * {
    box-sizing: border-box;
  }
  button {
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    font-family: inherit;
  }
  input,
  textarea,
  select {
    font-family: inherit;
  }
  p,
  h1,
  h2 {
    margin: 0;
  }
`;

// ─── Icon ─────────────────────────────────────────────────────────────────────
function Icon({ className }: { className?: string }) {
  return (
    <div
      className={className}
      css={css`
        display: flex;
        height: 18px;
        align-items: center;
        justify-content: center;
        position: relative;
      `}
    >
      <div
        css={css`
          height: 18px;
          position: relative;
          flex-shrink: 0;
          width: 17px;
        `}
      >
        <div
          css={css`
            position: absolute;
            inset: 11.11% 0;
          `}
        >
          <img
            alt=""
            css={css`
              display: block;
              max-width: none;
              width: 100%;
              height: 100%;
            `}
            src={imgShape}
          />
        </div>
      </div>
    </div>
  );
}

// ─── Component4 (hero showcase) ──────────────────────────────────────────────
function Component4() {
  return (
    <div
      css={css`
        background: #f9f9f6;
        height: 796px;
        overflow: clip;
        position: relative;
        border-radius: 16px;
        width: 628px;
      `}
    >
      <div
        css={css`
          position: absolute;
          height: 564px;
          left: 91.76px;
          top: 137px;
          width: 471.773px;
        `}
      >
        {/* Card 1 */}
        <div
          css={css`
            position: absolute;
            display: flex;
            height: 292.672px;
            align-items: center;
            justify-content: center;
            left: 0;
            top: 147.84px;
            width: 211.515px;
          `}
        >
          <div
            css={css`
              flex: none;
              animation: float1 4s ease-in-out infinite;
            `}
          >
            <div
              css={css`
                background: white;
                border: 0.623px solid rgba(55, 49, 47, 0.12);
                display: flex;
                flex-direction: column;
                gap: 9.973px;
                align-items: flex-start;
                padding: 19.946px;
                position: relative;
                border-radius: 14.959px;
                box-shadow:
                  0px 5.881px 14.045px 0px rgba(0, 0, 0, 0.09),
                  0px 1.98px 3.06px 0px rgba(0, 0, 0, 0.05),
                  0px 1px 1px 0px rgba(0, 0, 0, 0.05);
                width: 199.456px;
              `}
            >
              <div
                css={css`
                  display: flex;
                  font-weight: 500;
                  gap: 4.986px;
                  align-items: flex-start;
                  position: relative;
                  flex-shrink: 0;
                  width: 100%;
                `}
              >
                <p
                  css={css`
                    flex: 1 0 0;
                    line-height: normal;
                    min-width: 0;
                    position: relative;
                    font-size: 12.129px;
                    color: #241a17;
                  `}
                >
                  Ceramics for beginners e-book
                </p>
                <div
                  css={css`
                    height: 16.206px;
                    line-height: 0;
                    position: relative;
                    flex-shrink: 0;
                    text-align: right;
                    width: 47.994px;
                    white-space: nowrap;
                  `}
                >
                  <div
                    css={css`
                      transform: translateX(-100%) translateY(-50%);
                      position: absolute;
                      display: flex;
                      flex-direction: column;
                      justify-content: center;
                      left: 47.8px;
                      font-size: 12px;
                      color: #241a17;
                      top: 6px;
                    `}
                  >
                    <p
                      css={css`
                        line-height: 17.587px;
                      `}
                    >
                      $80
                    </p>
                  </div>
                  <div
                    css={css`
                      transform: translateX(-100%) translateY(-50%);
                      position: absolute;
                      display: flex;
                      flex-direction: column;
                      justify-content: center;
                      left: 23.7px;
                      font-size: 8px;
                      color: rgba(57, 57, 45, 0.52);
                      top: 6px;
                    `}
                  >
                    <p
                      css={css`
                        line-height: 17.587px;
                        text-decoration: line-through;
                      `}
                    >
                      $155
                    </p>
                  </div>
                </div>
              </div>
              <div
                css={css`
                  height: 169.538px;
                  position: relative;
                  border-radius: 10px;
                  flex-shrink: 0;
                  width: 100%;
                  overflow: hidden;
                `}
              >
                <img
                  alt=""
                  css={css`
                    position: absolute;
                    height: 321.09%;
                    left: -61.99%;
                    max-width: none;
                    top: -122.56%;
                    width: 214.06%;
                  `}
                  src={imgImage}
                />
              </div>
              <div
                css={css`
                  background: #f4f4f0;
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  justify-content: center;
                  overflow: clip;
                  padding: 4.986px 14.959px;
                  position: relative;
                  border-radius: 4.986px;
                  flex-shrink: 0;
                  width: 159.565px;
                `}
              >
                <p
                  css={css`
                    font-weight: 500;
                    line-height: 9.324px;
                    color: #111110;
                    font-size: 6.22px;
                    letter-spacing: 0.0622px;
                    white-space: nowrap;
                  `}
                >
                  Add to order
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* Card 2 */}
        <div
          css={css`
            transform: translateX(-50%);
            position: absolute;
            display: flex;
            height: 347.306px;
            align-items: center;
            justify-content: center;
            left: calc(50% + 23.31px);
            top: 216.71px;
            width: 230.348px;
          `}
        >
          <div
            css={css`
              flex: none;
              animation: float2 5s ease-in-out infinite;
            `}
          >
            <div
              css={css`
                background: white;
                border: 0.623px solid rgba(55, 49, 47, 0.12);
                display: flex;
                flex-direction: column;
                gap: 9.973px;
                align-items: center;
                justify-content: center;
                padding: 19.946px;
                position: relative;
                border-radius: 14.959px;
                box-shadow:
                  0px 5.881px 14.045px 0px rgba(0, 0, 0, 0.09),
                  0px 1.98px 3.06px 0px rgba(0, 0, 0, 0.05),
                  0px 1px 1px 0px rgba(0, 0, 0, 0.05);
                width: 220px;
              `}
            >
              <div
                css={css`
                  height: 233.113px;
                  position: relative;
                  border-radius: 10px;
                  flex-shrink: 0;
                  width: 186.49px;
                  overflow: hidden;
                `}
              >
                <img
                  alt=""
                  css={css`
                    position: absolute;
                    height: 120.57%;
                    left: -0.14%;
                    max-width: none;
                    top: -18.46%;
                    width: 100.18%;
                  `}
                  src={imgImage1}
                />
              </div>
              <div
                css={css`
                  display: flex;
                  flex-direction: column;
                  gap: 5.828px;
                  align-items: flex-start;
                  position: relative;
                  flex-shrink: 0;
                `}
              >
                <div
                  css={css`
                    display: flex;
                    flex-direction: column;
                    gap: 2.914px;
                    align-items: flex-start;
                    white-space: nowrap;
                  `}
                >
                  <p
                    css={css`
                      font-weight: 500;
                      line-height: normal;
                      font-size: 12.129px;
                      color: #241a17;
                    `}
                  >
                    Monthly Mixologist Masterclass
                  </p>
                  <p
                    css={css`
                      font-weight: 400;
                      line-height: 15.161px;
                      font-size: 10.613px;
                      color: rgba(17, 17, 16, 0.65);
                    `}
                  >
                    Master the art of cocktails
                  </p>
                </div>
                <div
                  css={css`
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                    position: relative;
                    flex-shrink: 0;
                    width: 100%;
                  `}
                >
                  <div
                    css={css`
                      display: flex;
                      flex-direction: column;
                      font-weight: 500;
                      justify-content: center;
                      line-height: 0;
                      font-size: 13.645px;
                      color: #241a17;
                      text-align: right;
                      white-space: nowrap;
                    `}
                  >
                    <p
                      css={css`
                        line-height: 17.587px;
                      `}
                    >
                      $39/mo
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Title */}
        <div
          css={css`
            transform: translateX(-50%) translateY(-50%);
            position: absolute;
            display: flex;
            flex-direction: column;
            font-weight: 500;
            justify-content: center;
            line-height: 34.034px;
            left: calc(50% - 13.64px);
            font-size: 30px;
            color: #241a17;
            text-align: center;
            top: 34.5px;
            white-space: pre;
          `}
        >
          <p
            css={css`
              margin-bottom: 0;
            `}
          >
            {'Create your product '}
          </p>
          <p>and start selling everywhere</p>
        </div>
        {/* Card 3 */}
        <div
          css={css`
            position: absolute;
            display: flex;
            height: 117.003px;
            align-items: center;
            justify-content: center;
            left: 221.24px;
            top: 158px;
            width: 250.529px;
          `}
        >
          <div
            css={css`
              flex: none;
              animation: float3 3.5s ease-in-out infinite;
            `}
          >
            <div
              css={css`
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                position: relative;
                box-shadow: 0px 13.941px 40.895px 0px rgba(0, 0, 0, 0.1);
                width: 242.581px;
              `}
            >
              <div
                css={css`
                  background: white;
                  border: 0.623px solid rgba(55, 49, 47, 0.12);
                  display: flex;
                  gap: 9.973px;
                  height: 94px;
                  align-items: flex-start;
                  padding: 19.946px;
                  position: relative;
                  border-radius: 14.959px;
                  flex-shrink: 0;
                  width: 100%;
                `}
              >
                <div
                  css={css`
                    position: relative;
                    border-radius: 10px;
                    flex-shrink: 0;
                    width: 57.613px;
                    height: 57.613px;
                    overflow: hidden;
                  `}
                >
                  <img
                    alt=""
                    css={css`
                      position: absolute;
                      height: 149.96%;
                      left: 0;
                      max-width: none;
                      top: -33.07%;
                      width: 100%;
                    `}
                    src={imgImage2}
                  />
                </div>
                <div
                  css={css`
                    display: flex;
                    flex: 1 0 0;
                    flex-direction: column;
                    gap: 6.065px;
                    align-items: flex-start;
                    min-width: 0;
                    position: relative;
                  `}
                >
                  <div
                    css={css`
                      font-weight: 500;
                      height: 30.323px;
                      line-height: normal;
                      font-size: 12.129px;
                      color: #241a17;
                      width: 100%;
                      white-space: pre-wrap;
                    `}
                  >
                    <p
                      css={css`
                        margin-bottom: 0;
                      `}
                    >
                      {'Hand-blown '}
                    </p>
                    <p>Glass Vase</p>
                  </div>
                  <div
                    css={css`
                      display: flex;
                      align-items: center;
                      justify-content: space-between;
                      position: relative;
                      flex-shrink: 0;
                      width: 100%;
                      white-space: nowrap;
                    `}
                  >
                    <p
                      css={css`
                        font-weight: 400;
                        line-height: 15.161px;
                        font-size: 10.613px;
                        color: rgba(17, 17, 16, 0.65);
                        text-decoration: underline;
                      `}
                    >
                      See more
                    </p>
                    <div
                      css={css`
                        display: flex;
                        flex-direction: column;
                        font-weight: 500;
                        justify-content: center;
                        line-height: 0;
                        font-size: 13.645px;
                        color: #241a17;
                        text-align: right;
                      `}
                    >
                      <p
                        css={css`
                          line-height: 17.587px;
                        `}
                      >
                        $129
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Bottom card */}
      <div
        css={css`
          position: absolute;
          display: flex;
          height: 532.991px;
          align-items: center;
          justify-content: center;
          left: 91.75px;
          top: 812.67px;
          width: 374.509px;
        `}
      >
        <div
          css={css`
            flex: none;
            transform: rotate(-6.5deg);
          `}
        >
          <div
            css={css`
              background: white;
              border: 1px solid rgba(55, 55, 52, 0.12);
              display: flex;
              flex-direction: column;
              gap: 16px;
              align-items: flex-start;
              padding: 24px;
              position: relative;
              border-radius: 10px;
              width: 320px;
            `}
          >
            <div
              css={css`
                background: #f9f9f6;
                border-radius: 6px;
                flex-shrink: 0;
                width: 272px;
                height: 272px;
              `}
            />
            <div
              css={css`
                display: flex;
                flex-direction: column;
                gap: 8px;
                align-items: flex-start;
                position: relative;
                flex-shrink: 0;
                width: 100%;
              `}
            >
              <div
                css={css`
                  display: flex;
                  flex-direction: column;
                  gap: 8px;
                  align-items: flex-start;
                  color: #10100f;
                  width: 100%;
                `}
              >
                <p
                  css={css`
                    font-weight: 500;
                    line-height: 24px;
                    font-size: 16px;
                    white-space: nowrap;
                  `}
                >
                  Brand Photography Masterclass
                </p>
                <p
                  css={css`
                    font-weight: 400;
                    line-height: 20px;
                    font-size: 14px;
                    width: 272px;
                  `}
                >
                  Jump on a 30 minute call with me to look over your plans, answer the nagging
                  questions, and make sure your trip is set up to be smooth and stress-free
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// ─── Component2 (delivery toggle) ────────────────────────────────────────────
type Component2Props = { deliveryType: string; onToggle: (v: string) => void };
function Component2({ deliveryType, onToggle }: Component2Props) {
  const isRedirect = deliveryType === 'redirect-url';
  return (
    <div
      css={css`
        background: rgba(17, 17, 0, 0.04);
        display: flex;
        height: 48px;
        align-items: center;
        padding: 2px;
        position: relative;
        border-radius: 10px;
        width: 500px;
      `}
    >
      <button
        type="button"
        onClick={() => onToggle('delivery-page')}
        css={css`
          display: flex;
          flex: 1 0 0;
          height: 44px;
          align-items: center;
          justify-content: center;
          padding: 0 12px;
          border-radius: 8px;
          ${!isRedirect ? 'background:white;' : ''}
        `}
      >
        <p
          css={css`
            font-weight: 500;
            line-height: 20px;
            font-size: 14px;
            white-space: nowrap;
            ${!isRedirect ? 'color:#111110;' : 'color:rgba(17,17,0,0.6);'}
          `}
        >
          Send to delivery page
        </p>
      </button>
      <button
        type="button"
        onClick={() => onToggle('redirect-url')}
        css={css`
          display: flex;
          flex: 1 0 0;
          height: 44px;
          align-items: center;
          justify-content: center;
          padding: 0 12px;
          border-radius: 8px;
          ${isRedirect ? 'background:white;' : ''}
        `}
      >
        <p
          css={css`
            font-weight: 500;
            line-height: 20px;
            font-size: 14px;
            white-space: nowrap;
            ${isRedirect ? 'color:#111110;' : 'color:rgba(17,17,0,0.6);'}
          `}
        >
          Redirect to URL
        </p>
      </button>
    </div>
  );
}

// ─── Switch ───────────────────────────────────────────────────────────────────
type SwitchProps = {
  active?: boolean;
  label?: boolean;
  hint?: boolean;
  onToggle?: (v: boolean) => void;
};
function Switch({ active: controlledActive, label = true, hint = false, onToggle }: SwitchProps) {
  const [internalActive, setInternalActive] = useState(false);
  const isControlled = controlledActive !== undefined;
  const active = isControlled ? controlledActive : internalActive;
  const handleClick = () => {
    if (isControlled) {
      if (onToggle) {
        onToggle(!active);
      }
    } else {
      setInternalActive(v => !v);
    }
  };
  return (
    <div
      role="button"
      tabIndex={0}
      onClick={handleClick}
      onKeyDown={e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleClick();
        }
      }}
      css={css`
        display: flex;
        gap: 8px;
        align-items: flex-start;
        position: relative;
        cursor: pointer;
      `}
    >
      <div
        css={css`
          display: inline-grid;
          place-items: start;
          position: relative;
          flex-shrink: 0;
        `}
      >
        <div
          css={css`
            height: 20px;
            width: 32px;
            border-radius: 120px;
            transition: background 0.2s;
            background: ${active ? '#10100f' : '#b9b9ac'};
          `}
        />
        <div
          css={css`
            position: absolute;
            top: 2px;
            left: ${active ? '14px' : '1.6px'};
            background: white;
            border-radius: 56px;
            width: 16px;
            height: 16px;
            transition: left 0.2s;
          `}
        />
      </div>
      {label && (
        <div
          css={css`
            display: flex;
            flex-direction: column;
            align-items: flex-start;
          `}
        >
          <p
            css={css`
              font-weight: 500;
              line-height: 20px;
              font-size: 14px;
              color: #10100f;
              white-space: nowrap;
            `}
          >
            Label
          </p>
          {hint && (
            <p
              css={css`
                font-weight: 400;
                line-height: 20px;
                font-size: 14px;
                color: rgba(61, 46, 41, 0.52);
                white-space: nowrap;
              `}
            >
              Hint
            </p>
          )}
        </div>
      )}
    </div>
  );
}

// ─── Textfield (testimonial) ──────────────────────────────────────────────────
type TextfieldProps = {
  customerName: string;
  onNameChange: (v: string) => void;
  testimonialText: string;
  onTextChange: (v: string) => void;
  enabled: boolean;
  onToggle: (v: boolean) => void;
};
function Textfield({
  customerName,
  onNameChange,
  testimonialText,
  onTextChange,
  enabled,
  onToggle,
}: TextfieldProps) {
  return (
    <div
      css={css`
        background: #f9f9f6;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        overflow: clip;
        padding: 0 16px;
        position: relative;
        border-radius: 10px;
        width: 500px;
      `}
    >
      <div
        css={css`
          background: #f9f9f6;
          position: relative;
          border-radius: 10px;
          flex-shrink: 0;
          width: 100%;
        `}
      >
        <div
          css={css`
            display: flex;
            flex-direction: column;
            padding: 14px 0;
            position: relative;
            width: 100%;
            gap: 0;
          `}
        >
          <div
            css={css`
              display: flex;
              align-items: center;
              justify-content: space-between;
              position: relative;
              flex-shrink: 0;
              width: 100%;
            `}
          >
            <p
              css={css`
                font-weight: 500;
                line-height: 20px;
                font-size: 14px;
                color: #241a17;
              `}
            >
              Testimonial
            </p>
            <Switch label={false} active={enabled} onToggle={onToggle} />
          </div>
          <p
            css={css`
              font-weight: 400;
              line-height: 20px;
              font-size: 14px;
              color: rgba(61, 46, 41, 0.52);
            `}
          >
            Add a testimonial to your checkout page
          </p>
          <AnimatePresence>
            {enabled && (
              <motion.div
                key="testimonial-fields"
                initial={{ opacity: 0, height: 0 }}
                animate={{ opacity: 1, height: 'auto' }}
                exit={{ opacity: 0, height: 0 }}
                transition={{ type: 'spring', stiffness: 160, damping: 28, mass: 1 }}
                css={css`
                  overflow: hidden;
                `}
              >
                <div
                  css={css`
                    display: flex;
                    flex-direction: column;
                    gap: 8px;
                    padding-top: 14px;
                  `}
                >
                  <div
                    css={css`
                      display: flex;
                      flex-direction: column;
                      gap: 8px;
                    `}
                  >
                    <p
                      css={css`
                        font-weight: 400;
                        line-height: 20px;
                        font-size: 14px;
                        color: #241a17;
                      `}
                    >
                      Testimonial
                    </p>
                    <div
                      css={css`
                        background: white;
                        border: 1px solid rgba(58, 58, 44, 0.23);
                        padding: 12px 18px;
                        border-radius: 6px;
                        width: 100%;
                      `}
                    >
                      <textarea
                        value={testimonialText}
                        onChange={e => onTextChange(e.target.value)}
                        placeholder='"My inbox is full of new inquiries!"'
                        rows={4}
                        css={css`
                          width: 100%;
                          font-weight: 400;
                          font-size: 14px;
                          color: #10100f;
                          background: transparent;
                          border: none;
                          outline: none;
                          resize: none;
                          line-height: 20px;
                          font-family: inherit;
                          &::placeholder {
                            color: rgba(61, 46, 41, 0.52);
                          }
                        `}
                      />
                    </div>
                  </div>
                  <div
                    css={css`
                      display: flex;
                      flex-direction: column;
                      gap: 8px;
                    `}
                  >
                    <p
                      css={css`
                        font-weight: 400;
                        line-height: 20px;
                        font-size: 14px;
                        color: #241a17;
                      `}
                    >
                      Customer name
                    </p>
                    <div
                      css={css`
                        background: white;
                        border: 1px solid rgba(58, 58, 44, 0.23);
                        display: flex;
                        gap: 8px;
                        height: 48px;
                        align-items: center;
                        padding: 0 18px;
                        border-radius: 6px;
                        width: 100%;
                      `}
                    >
                      <input
                        type="text"
                        value={customerName}
                        onChange={e => onNameChange(e.target.value)}
                        placeholder="Stuart R."
                        css={css`
                          flex: 1;
                          font-weight: 400;
                          font-size: 14px;
                          color: #10100f;
                          background: transparent;
                          border: none;
                          outline: none;
                          font-family: inherit;
                          &::placeholder {
                            color: rgba(61, 46, 41, 0.52);
                          }
                        `}
                      />
                    </div>
                  </div>
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
}

// ─── Component3 (bump offer) ──────────────────────────────────────────────────
type Component3Props = {
  onBumpSelect: (v: boolean) => void;
  bumpOfferTitle: string;
  onBumpTitleChange: (v: string) => void;
  hasBumpOffer: boolean;
};
function Component3({
  onBumpSelect,
  bumpOfferTitle,
  onBumpTitleChange,
  hasBumpOffer,
}: Component3Props) {
  const [selectValue, setSelectValue] = useState('');
  const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectValue(e.target.value);
    onBumpSelect(e.target.value !== '');
  };
  const handleClear = () => {
    setSelectValue('');
    onBumpSelect(false);
  };
  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        position: relative;
        width: 468px;
      `}
    >
      <div
        css={css`
          display: flex;
          flex-direction: column;
          gap: 16px;
          align-items: flex-start;
          position: relative;
          flex-shrink: 0;
          width: 100%;
        `}
      >
        <div
          css={css`
            display: flex;
            align-items: flex-start;
            position: relative;
            flex-shrink: 0;
            width: 100%;
          `}
        >
          <div
            css={css`
              display: flex;
              flex: 1 0 0;
              flex-direction: column;
              align-items: flex-start;
              justify-content: center;
              min-width: 0;
              position: relative;
              border-radius: 3px;
            `}
          >
            <div
              css={css`
                display: flex;
                flex-direction: column;
                gap: 8px;
                align-items: flex-start;
                position: relative;
                flex-shrink: 0;
                width: 100%;
              `}
            >
              <div
                css={css`
                  display: flex;
                  flex-direction: column;
                  align-items: flex-start;
                  position: relative;
                  flex-shrink: 0;
                  width: 100%;
                `}
              >
                <p
                  css={css`
                    font-weight: 400;
                    line-height: 20px;
                    font-size: 14px;
                    color: #241a17;
                  `}
                >
                  Choose an offer
                </p>
              </div>
              <div
                css={css`
                  background: white;
                  display: flex;
                  flex-direction: column;
                  align-items: flex-start;
                  position: relative;
                  flex-shrink: 0;
                  width: 100%;
                `}
              >
                <div
                  css={css`
                    border: 1px solid rgba(61, 46, 41, 0.24);
                    display: flex;
                    gap: 8px;
                    height: 48px;
                    align-items: center;
                    padding: 0 19px;
                    position: relative;
                    border-radius: 6px;
                    flex-shrink: 0;
                    width: 100%;
                    overflow: hidden;
                  `}
                >
                  <select
                    css={css`
                      flex: 1;
                      height: 100%;
                      background: transparent;
                      font-weight: 400;
                      font-size: 14px;
                      color: #241a17;
                      border: none;
                      outline: none;
                      appearance: none;
                      cursor: pointer;
                      font-family: inherit;
                    `}
                    value={selectValue}
                    onChange={handleSelectChange}
                  >
                    <option value="" disabled>
                      Select a product
                    </option>
                    <option value="upgrade-1-hour">Upgrade to One Hour — $20</option>
                    <option value="extra-30min">30 Extra Minutes — $15</option>
                  </select>
                  {hasBumpOffer ? (
                    <button
                      type="button"
                      onClick={handleClear}
                      css={css`
                        flex-shrink: 0;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        width: 18px;
                        height: 18px;
                        color: #241a17;
                        cursor: pointer;
                        transition: opacity 0.15s;
                        &:hover {
                          opacity: 0.6;
                        }
                      `}
                      aria-label="Clear bump offer"
                    >
                      <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                        <path
                          d="M1 1L9 9M9 1L1 9"
                          stroke="#241a17"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                        />
                      </svg>
                    </button>
                  ) : (
                    <div
                      css={css`
                        pointer-events: none;
                        flex-shrink: 0;
                      `}
                    >
                      <div
                        css={css`
                          height: 18px;
                          position: relative;
                          flex-shrink: 0;
                          width: 10px;
                        `}
                      >
                        <div
                          css={css`
                            position: absolute;
                            inset: 36.81% 0 31.25% 0;
                          `}
                        >
                          <img
                            alt=""
                            css={css`
                              display: block;
                              max-width: none;
                              width: 100%;
                              height: 100%;
                            `}
                            src={imgShape1}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          css={css`
            display: flex;
            flex-direction: column;
            gap: 8px;
            align-items: flex-start;
            position: relative;
            flex-shrink: 0;
            width: 100%;
          `}
        >
          <p
            css={css`
              font-weight: 400;
              line-height: 20px;
              font-size: 14px;
              color: #241a17;
            `}
          >
            Offer title
          </p>
          <div
            css={css`
              background: white;
              border: 1px solid rgba(58, 58, 44, 0.23);
              display: flex;
              gap: 8px;
              height: 48px;
              align-items: center;
              padding: 0 18px;
              position: relative;
              border-radius: 6px;
              flex-shrink: 0;
              width: 100%;
            `}
          >
            <input
              type="text"
              value={bumpOfferTitle}
              onChange={e => onBumpTitleChange(e.target.value)}
              placeholder="Offer title"
              css={css`
                flex: 1;
                font-weight: 400;
                height: 20px;
                line-height: 20px;
                font-size: 14px;
                color: #241a17;
                background: transparent;
                border: none;
                outline: none;
                font-family: inherit;
                &::placeholder {
                  color: #88887c;
                }
              `}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

// ─── Container (waitlist) ─────────────────────────────────────────────────────
function WaitlistContainer() {
  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        position: relative;
        width: 500px;
      `}
    >
      <div
        css={css`
          background: #f9f9f6;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          padding: 14px 16px;
          position: relative;
          border-radius: 10px;
          flex-shrink: 0;
          width: 100%;
        `}
      >
        <div
          css={css`
            position: relative;
            flex-shrink: 0;
            width: 468px;
          `}
        >
          <div
            css={css`
              display: flex;
              align-items: center;
              justify-content: space-between;
              position: relative;
              width: 100%;
            `}
          >
            <div
              css={css`
                display: flex;
                flex: 1 0 0;
                align-items: center;
                justify-content: space-between;
                min-width: 0;
                position: relative;
              `}
            >
              <p
                css={css`
                  flex: 1 0 0;
                  font-weight: 500;
                  line-height: 20px;
                  min-width: 0;
                  font-size: 14px;
                  color: #241a17;
                `}
              >
                Allow waitlist
              </p>
              <Switch label={false} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// ─── Component1 (checkout expiry) ─────────────────────────────────────────────
function CheckoutExpiry() {
  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        position: relative;
        width: 500px;
      `}
    >
      <div
        css={css`
          background: #f9f9f6;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          padding: 14px 16px;
          position: relative;
          border-radius: 10px;
          flex-shrink: 0;
          width: 100%;
        `}
      >
        <div
          css={css`
            position: relative;
            flex-shrink: 0;
            width: 468px;
          `}
        >
          <div
            css={css`
              display: flex;
              align-items: center;
              justify-content: space-between;
              position: relative;
              width: 100%;
            `}
          >
            <div
              css={css`
                display: flex;
                flex: 1 0 0;
                align-items: center;
                justify-content: space-between;
                min-width: 0;
                position: relative;
              `}
            >
              <p
                css={css`
                  flex: 1 0 0;
                  font-weight: 500;
                  line-height: 20px;
                  min-width: 0;
                  font-size: 14px;
                  color: #241a17;
                `}
              >
                Checkout expiry
              </p>
              <Switch label={false} />
            </div>
          </div>
        </div>
        <p
          css={css`
            font-weight: 400;
            line-height: 20px;
            min-width: 100%;
            font-size: 14px;
            color: rgba(61, 46, 41, 0.52);
          `}
        >
          Define the date, time, and timezone when your offer should end
        </p>
      </div>
    </div>
  );
}

// ─── Section (inventory) ──────────────────────────────────────────────────────
function InventorySection() {
  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        position: relative;
        width: 500px;
      `}
    >
      <div
        css={css`
          background: #f9f9f6;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          padding: 14px 16px;
          position: relative;
          border-radius: 10px;
          flex-shrink: 0;
          width: 100%;
        `}
      >
        <div
          css={css`
            position: relative;
            flex-shrink: 0;
            width: 468px;
          `}
        >
          <div
            css={css`
              display: flex;
              align-items: center;
              justify-content: space-between;
              position: relative;
              width: 100%;
            `}
          >
            <div
              css={css`
                display: flex;
                flex: 1 0 0;
                align-items: center;
                justify-content: space-between;
                min-width: 0;
                position: relative;
              `}
            >
              <p
                css={css`
                  flex: 1 0 0;
                  font-weight: 500;
                  line-height: 20px;
                  min-width: 0;
                  font-size: 14px;
                  color: #241a17;
                `}
              >
                Limit inventory
              </p>
              <Switch label={false} />
            </div>
          </div>
        </div>
        <p
          css={css`
            font-weight: 400;
            line-height: 20px;
            font-size: 14px;
            color: rgba(61, 46, 41, 0.52);
            width: 436px;
          `}
        >
          Decide on availability. When your product sells out, we will show the sold out page
        </p>
      </div>
    </div>
  );
}

// ─── SalesTaxContent ──────────────────────────────────────────────────────────
function SalesTaxContent() {
  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        position: relative;
        width: 500px;
      `}
    >
      <div
        css={css`
          background: #f9f9f6;
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 14px 16px;
          position: relative;
          border-radius: 10px;
          flex-shrink: 0;
          width: 100%;
        `}
      >
        <div
          css={css`
            position: relative;
            flex-shrink: 0;
            width: 468px;
          `}
        >
          <div
            css={css`
              display: flex;
              align-items: center;
              justify-content: space-between;
              position: relative;
              width: 100%;
            `}
          >
            <div
              css={css`
                display: flex;
                flex: 1 0 0;
                align-items: center;
                justify-content: space-between;
                min-width: 0;
                position: relative;
              `}
            >
              <p
                css={css`
                  flex: 1 0 0;
                  font-weight: 500;
                  line-height: 20px;
                  min-width: 0;
                  font-size: 14px;
                  color: #241a17;
                `}
              >
                Enable sales tax
              </p>
              <Switch label={false} />
            </div>
          </div>
        </div>
        <p
          css={css`
            font-weight: 400;
            line-height: 20px;
            min-width: 100%;
            font-size: 14px;
            color: rgba(61, 46, 41, 0.52);
          `}
        >
          Automatically calculate and collect relevant taxes for all products listed in this
          checkout.{' '}
          <span
            css={css`
              text-decoration: underline;
            `}
          >
            Learn more
          </span>
        </p>
      </div>
    </div>
  );
}

// ─── PaymentPlan ──────────────────────────────────────────────────────────────
function PaymentPlan() {
  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        position: relative;
        width: 500px;
      `}
    >
      <div
        css={css`
          background: #f9f9f6;
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 14px 16px;
          position: relative;
          border-radius: 10px;
          flex-shrink: 0;
          width: 100%;
        `}
      >
        <div
          css={css`
            position: relative;
            flex-shrink: 0;
            width: 468px;
          `}
        >
          <div
            css={css`
              display: flex;
              align-items: center;
              justify-content: space-between;
              position: relative;
              width: 100%;
            `}
          >
            <div
              css={css`
                display: flex;
                flex: 1 0 0;
                align-items: center;
                justify-content: space-between;
                min-width: 0;
                position: relative;
              `}
            >
              <p
                css={css`
                  flex: 1 0 0;
                  font-weight: 500;
                  line-height: 20px;
                  min-width: 0;
                  font-size: 14px;
                  color: #241a17;
                `}
              >
                Allow payment plan
              </p>
              <Switch label={false} />
            </div>
          </div>
        </div>
        <p
          css={css`
            font-weight: 400;
            line-height: 20px;
            min-width: 100%;
            font-size: 14px;
            color: rgba(61, 46, 41, 0.52);
          `}
        >
          Break up big buys into bite-sized payments
        </p>
      </div>
    </div>
  );
}

// ─── Image upload ─────────────────────────────────────────────────────────────
type ImageProps = { onImageChange: (v: string) => void };
function ImageUpload({ onImageChange }: ImageProps) {
  const fileRef = useRef<HTMLInputElement>(null);
  const [preview, setPreview] = useState<string | null>(null);

  function handleFile(file: File | undefined) {
    if (!file || !file.type.startsWith('image/')) return;
    const reader = new FileReader();
    reader.onload = e => {
      const result = e.target?.result as string;
      setPreview(result);
      onImageChange(result);
    };
    reader.readAsDataURL(file);
  }

  function handleDrop(e: React.DragEvent) {
    e.preventDefault();
    handleFile(e.dataTransfer.files[0]);
  }

  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: flex-start;
        position: relative;
        width: 242px;
      `}
    >
      <p
        css={css`
          font-weight: 500;
          line-height: 20px;
          font-size: 14px;
          color: #111110;
          white-space: nowrap;
        `}
      >
        Product image
      </p>
      <div
        css={css`
          ${!preview ? 'border:1px dashed rgba(58,58,44,0.3);' : ''}display:flex;
          flex-direction: column;
          gap: 12px;
          height: 242px;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          position: relative;
          border-radius: 6px;
          flex-shrink: 0;
          width: 100%;
          cursor: pointer;
        `}
        role="button"
        tabIndex={0}
        onClick={() => fileRef.current?.click()}
        onKeyDown={e => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            fileRef.current?.click();
          }
        }}
        onDrop={handleDrop}
        onDragOver={e => e.preventDefault()}
      >
        {preview ? (
          <img
            src={preview}
            alt="Product"
            css={css`
              position: absolute;
              inset: 0;
              width: 100%;
              height: 100%;
              object-fit: cover;
            `}
          />
        ) : (
          <>
            <p
              css={css`
                font-weight: 400;
                line-height: 20px;
                font-size: 14px;
                color: #10100f;
                text-align: center;
                width: 148px;
              `}
            >
              Drag and drop an image here
            </p>
            <p
              css={css`
                font-weight: 400;
                line-height: 20px;
                font-size: 14px;
                color: #111110;
                text-align: center;
              `}
            >
              or
            </p>
            <button
              type="button"
              css={css`
                background: #111110;
                display: flex;
                gap: 8px;
                height: 40px;
                align-items: center;
                justify-content: center;
                padding: 0 20px;
                border-radius: 50px;
                flex-shrink: 0;
              `}
            >
              <p
                css={css`
                  font-weight: 500;
                  line-height: 20px;
                  font-size: 14px;
                  color: #f0f0eb;
                  white-space: nowrap;
                `}
              >
                Select file
              </p>
            </button>
          </>
        )}
      </div>
      <input
        ref={fileRef}
        type="file"
        accept="image/*"
        css={css`
          display: none;
        `}
        onChange={e => handleFile(e.target.files?.[0])}
      />
    </div>
  );
}

// ─── CheckoutPage ─────────────────────────────────────────────────────────────
type CheckoutPageProps = {
  productName: string;
  productDescription: string;
  productImage: string | null;
  productPrice: string;
  productSalesPrice: string;
  isFree: boolean;
  isRecurring: boolean;
  hasBumpOffer: boolean;
  bumpOfferTitle: string;
  testimonialName: string;
  testimonialText: string;
  hasTestimonial: boolean;
  isMobile: boolean;
};
function CheckoutPage({
  productName,
  productDescription,
  productImage,
  productPrice,
  productSalesPrice,
  isFree,
  isRecurring,
  hasBumpOffer,
  bumpOfferTitle,
  testimonialName,
  testimonialText,
  hasTestimonial,
  isMobile,
}: CheckoutPageProps) {
  const hasPrice = isRecurring || isFree || !!productPrice;

  function getDisplayPrice() {
    if (isRecurring) return '$39/mo';
    if (isFree) return 'FREE';
    if (productSalesPrice) return `$${productSalesPrice}`;
    if (productPrice) return `$${productPrice}`;
    return '';
  }
  const displayPrice = getDisplayPrice();

  function getButtonLabel() {
    if (isFree) return 'Get for free';
    if (isRecurring) return 'Subscribe — $39/mo';
    if (productPrice) return `Pay $${productSalesPrice || productPrice} now`;
    return 'Complete order';
  }
  const buttonLabel = getButtonLabel();

  const orderSummary = (
    <div
      css={css`
        ${isMobile
          ? 'width:100%;background:#f9f9f6;padding:32px 20px 24px;'
          : 'width:44%;flex-shrink:0;background:#f9f9f6;padding:40px;'}display:flex;
        flex-direction: column;
        gap: ${isMobile ? '18px' : '20px'};
      `}
    >
      <h2
        css={css`
          font-weight: 500;
          font-size: 18px;
          line-height: 1.3;
          color: #10100f;
        `}
      >
        Your order summary
      </h2>
      <div
        css={css`
          background: white;
          border: 1px solid rgba(0, 0, 0, 0.08);
          border-radius: 10px;
          overflow: hidden;
        `}
      >
        {productImage ? (
          <div
            css={css`
              width: 100%;
              aspect-ratio: 4/3;
              overflow: hidden;
            `}
          >
            <img
              src={productImage}
              alt=""
              css={css`
                width: 100%;
                height: 100%;
                object-fit: cover;
              `}
            />
          </div>
        ) : (
          <div
            css={css`
              width: 100%;
              aspect-ratio: 4/3;
              background: #eae9e4;
            `}
          />
        )}
        <div
          css={css`
            padding: 12px 16px 16px;
            display: flex;
            flex-direction: column;
            gap: 10px;
          `}
        >
          <div
            css={css`
              display: flex;
              flex-direction: column;
              gap: 4px;
            `}
          >
            <p
              css={css`
                font-weight: 500;
                font-size: 14px;
                line-height: 1.35;
                color: #10100f;
              `}
            >
              {productName || 'Product name'}
            </p>
            {productDescription && (
              <p
                css={css`
                  font-weight: 400;
                  font-size: 13px;
                  line-height: 1.5;
                  color: rgba(16, 16, 15, 0.5);
                  display: -webkit-box;
                  -webkit-line-clamp: 3;
                  -webkit-box-orient: vertical;
                  overflow: hidden;
                `}
              >
                {productDescription}
              </p>
            )}
          </div>
          <div
            css={css`
              display: flex;
              align-items: center;
              justify-content: space-between;
            `}
          >
            <span
              css={css`
                font-weight: 400;
                font-size: 13px;
                color: rgba(16, 16, 15, 0.4);
                text-decoration: underline;
                cursor: pointer;
              `}
            >
              See more
            </span>
            {hasPrice && (
              <div
                css={css`
                  display: flex;
                  align-items: baseline;
                  gap: 5px;
                `}
              >
                {(() => {
                  if (isRecurring)
                    return (
                      <span
                        css={css`
                          font-weight: 500;
                          font-size: 14px;
                          color: #10100f;
                        `}
                      >
                        $39/mo
                      </span>
                    );
                  if (isFree)
                    return (
                      <span
                        css={css`
                          font-weight: 500;
                          font-size: 14px;
                          color: #10100f;
                        `}
                      >
                        FREE
                      </span>
                    );
                  if (productSalesPrice)
                    return (
                      <>
                        <span
                          css={css`
                            font-weight: 500;
                            font-size: 14px;
                            color: #d33003;
                          `}
                        >
                          ${productSalesPrice}
                        </span>
                        <span
                          css={css`
                            font-size: 12px;
                            color: rgba(16, 16, 15, 0.35);
                            text-decoration: line-through;
                          `}
                        >
                          ${productPrice}
                        </span>
                      </>
                    );
                  return (
                    <span
                      css={css`
                        font-weight: 500;
                        font-size: 14px;
                        color: #10100f;
                      `}
                    >
                      ${productPrice}
                    </span>
                  );
                })()}
              </div>
            )}
          </div>
        </div>
      </div>
      {hasPrice && (
        <div
          css={css`
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 14px 0;
            border-top: 1px solid rgba(0, 0, 0, 0.08);
            border-bottom: 1px solid rgba(0, 0, 0, 0.08);
          `}
        >
          <span
            css={css`
              font-weight: 500;
              font-size: 14px;
              color: #10100f;
            `}
          >
            Total
          </span>
          <span
            css={css`
              font-weight: 500;
              font-size: 14px;
              color: #10100f;
            `}
          >
            {displayPrice}
          </span>
        </div>
      )}
      {hasBumpOffer && (
        <div
          css={css`
            background: white;
            border: 1px solid rgba(0, 0, 0, 0.08);
            border-radius: 10px;
            overflow: hidden;
          `}
        >
          <div
            css={css`
              display: flex;
              align-items: center;
              justify-content: space-between;
              padding: 10px 16px;
              border-bottom: 1px solid rgba(0, 0, 0, 0.06);
            `}
          >
            <span
              css={css`
                font-size: 11px;
                font-weight: 500;
                color: #10100f;
                text-transform: uppercase;
                letter-spacing: 0.06em;
              `}
            >
              {bumpOfferTitle || 'Special offer'}
            </span>
            <span
              css={css`
                font-weight: 500;
                font-size: 14px;
                color: #10100f;
              `}
            >
              $20
            </span>
          </div>
          <div
            css={css`
              width: 100%;
              aspect-ratio: 16/9;
              overflow: hidden;
            `}
          >
            <img
              src={imgBumpOffer}
              alt=""
              css={css`
                width: 100%;
                height: 100%;
                object-fit: cover;
              `}
            />
          </div>
          <div
            css={css`
              padding: 12px 16px 8px;
              display: flex;
              flex-direction: column;
              gap: 6px;
            `}
          >
            <p
              css={css`
                font-weight: 500;
                font-size: 13px;
                color: #10100f;
              `}
            >
              {bumpOfferTitle || 'Special offer'}
            </p>
            <p
              css={css`
                font-weight: 400;
                font-size: 12px;
                color: rgba(16, 16, 15, 0.5);
                line-height: 1.5;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
              `}
            >
              Add this exclusive one-time offer to your order before you check out. Available today
              only.
            </p>
            <span
              css={css`
                font-weight: 400;
                font-size: 12px;
                color: rgba(16, 16, 15, 0.55);
                text-decoration: underline;
                cursor: pointer;
              `}
            >
              See more
            </span>
          </div>
          <div
            css={css`
              padding: 8px 16px 16px;
            `}
          >
            <button
              type="button"
              css={css`
                width: 100%;
                height: 40px;
                background: #f4f4f0;
                border-radius: 6px;
                font-size: 13px;
                font-weight: 500;
                color: #10100f;
                font-family: inherit;
                cursor: pointer;
              `}
            >
              Add to order
            </button>
          </div>
        </div>
      )}
    </div>
  );

  const formSection = (
    <div
      css={css`
        ${isMobile
          ? 'width:100%;background:white;padding:24px 20px 32px;'
          : 'flex:1;background:white;padding:40px;'}display:flex;
        flex-direction: column;
        gap: 20px;
      `}
    >
      <h2
        css={css`
          font-weight: 500;
          font-size: 18px;
          line-height: 1.3;
          color: #10100f;
        `}
      >
        Contact information
      </h2>
      <div
        css={css`
          display: flex;
          flex-direction: column;
          gap: 10px;
        `}
      >
        <div
          css={css`
            display: flex;
            gap: 10px;
          `}
        >
          <div
            css={css`
              flex: 1;
              border: 1px solid rgba(58, 58, 44, 0.2);
              border-radius: 6px;
              height: 48px;
              padding: 0 14px;
              display: flex;
              align-items: center;
            `}
          >
            <span
              css={css`
                font-weight: 400;
                font-size: 14px;
                color: rgba(58, 58, 44, 0.35);
              `}
            >
              First name
            </span>
          </div>
          <div
            css={css`
              flex: 1;
              border: 1px solid rgba(58, 58, 44, 0.2);
              border-radius: 6px;
              height: 48px;
              padding: 0 14px;
              display: flex;
              align-items: center;
            `}
          >
            <span
              css={css`
                font-weight: 400;
                font-size: 14px;
                color: rgba(58, 58, 44, 0.35);
              `}
            >
              Last name
            </span>
          </div>
        </div>
        <div
          css={css`
            border: 1px solid rgba(58, 58, 44, 0.2);
            border-radius: 6px;
            height: 48px;
            padding: 0 14px;
            display: flex;
            align-items: center;
            width: 100%;
          `}
        >
          <span
            css={css`
              font-weight: 400;
              font-size: 14px;
              color: rgba(58, 58, 44, 0.35);
            `}
          >
            Email
          </span>
        </div>
        <div
          css={css`
            display: flex;
            align-items: center;
            gap: 10px;
            padding-top: 2px;
          `}
        >
          <div
            css={css`
              width: 16px;
              height: 16px;
              border: 1px solid rgba(58, 58, 44, 0.25);
              border-radius: 3px;
              flex-shrink: 0;
            `}
          />
          <span
            css={css`
              font-weight: 400;
              font-size: 13px;
              color: rgba(16, 16, 15, 0.65);
            `}
          >
            Sign up for my weekly newsletter
          </span>
        </div>
      </div>
      {!isFree && (
        <>
          <h2
            css={css`
              font-weight: 500;
              font-size: 18px;
              line-height: 1.3;
              color: #10100f;
            `}
          >
            Payment details
          </h2>
          <div
            css={css`
              border: 1px solid rgba(58, 58, 44, 0.18);
              border-radius: 8px;
              overflow: hidden;
            `}
          >
            <div
              css={css`
                padding: 16px 16px 12px;
                display: flex;
                flex-direction: column;
                gap: 10px;
              `}
            >
              <div
                css={css`
                  display: flex;
                  align-items: center;
                  gap: 10px;
                `}
              >
                <div
                  css={css`
                    width: 16px;
                    height: 16px;
                    border-radius: 50%;
                    border: 5px solid #10100f;
                    flex-shrink: 0;
                  `}
                />
                <svg width="22" height="16" viewBox="0 0 22 16" fill="none">
                  <rect
                    x="0.5"
                    y="0.5"
                    width="21"
                    height="15"
                    rx="2.5"
                    stroke="rgba(58,58,44,0.22)"
                  />
                  <rect y="4" width="22" height="4" fill="rgba(58,58,44,0.08)" />
                  <rect x="2" y="10" width="6" height="2" rx="1" fill="rgba(58,58,44,0.15)" />
                </svg>
                <span
                  css={css`
                    font-weight: 400;
                    font-size: 14px;
                    color: #10100f;
                  `}
                >
                  Card
                </span>
              </div>
              <div
                css={css`
                  border: 1px solid rgba(58, 58, 44, 0.2);
                  border-radius: 6px;
                  height: 48px;
                  padding: 0 14px;
                  display: flex;
                  align-items: center;
                `}
              >
                <span
                  css={css`
                    font-weight: 400;
                    font-size: 14px;
                    color: rgba(58, 58, 44, 0.35);
                    flex: 1;
                  `}
                >
                  Card number
                </span>
              </div>
              <div
                css={css`
                  display: flex;
                  gap: 10px;
                `}
              >
                <div
                  css={css`
                    flex: 1;
                    border: 1px solid rgba(58, 58, 44, 0.2);
                    border-radius: 6px;
                    height: 48px;
                    padding: 0 14px;
                    display: flex;
                    align-items: center;
                  `}
                >
                  <span
                    css={css`
                      font-weight: 400;
                      font-size: 14px;
                      color: rgba(58, 58, 44, 0.35);
                    `}
                  >
                    MM / YY
                  </span>
                </div>
                <div
                  css={css`
                    flex: 1;
                    border: 1px solid rgba(58, 58, 44, 0.2);
                    border-radius: 6px;
                    height: 48px;
                    padding: 0 14px;
                    display: flex;
                    align-items: center;
                  `}
                >
                  <span
                    css={css`
                      font-weight: 400;
                      font-size: 14px;
                      color: rgba(58, 58, 44, 0.35);
                    `}
                  >
                    CVC
                  </span>
                </div>
              </div>
              <div
                css={css`
                  display: flex;
                  gap: 10px;
                `}
              >
                <div
                  css={css`
                    flex: 1;
                    border: 1px solid rgba(58, 58, 44, 0.2);
                    border-radius: 6px;
                    height: 48px;
                    padding: 0 14px;
                    display: flex;
                    align-items: center;
                  `}
                >
                  <span
                    css={css`
                      font-weight: 400;
                      font-size: 14px;
                      color: rgba(58, 58, 44, 0.35);
                    `}
                  >
                    Country
                  </span>
                </div>
                <div
                  css={css`
                    flex: 1;
                    border: 1px solid rgba(58, 58, 44, 0.2);
                    border-radius: 6px;
                    height: 48px;
                    padding: 0 14px;
                    display: flex;
                    align-items: center;
                  `}
                >
                  <span
                    css={css`
                      font-weight: 400;
                      font-size: 14px;
                      color: rgba(58, 58, 44, 0.35);
                    `}
                  >
                    ZIP
                  </span>
                </div>
              </div>
            </div>
            <div
              css={css`
                height: 1px;
                background: rgba(58, 58, 44, 0.08);
              `}
            />
            <div
              css={css`
                padding: 10px 16px;
                display: flex;
                align-items: center;
                gap: 10px;
              `}
            >
              <div
                css={css`
                  width: 16px;
                  height: 16px;
                  border-radius: 50%;
                  border: 1px solid rgba(58, 58, 44, 0.25);
                  flex-shrink: 0;
                `}
              />
              <div
                css={css`
                  background: black;
                  border-radius: 4px;
                  padding: 0 7px;
                  height: 20px;
                  display: flex;
                  align-items: center;
                  gap: 3px;
                `}
              >
                <svg width="10" height="12" viewBox="0 0 10 12" fill="white">
                  <path d="M8.27 6.37c-.01-1.3.6-1.93 1.74-2.6-.65-.94-1.63-1.46-2.92-1.56C5.9 2.1 5.2 2.7 4.7 2.7c-.5 0-1.13-.56-1.87-.54C1.5 2.19.5 3.1.05 4.4c-.96 2.6.73 6.48 1.68 8.6.47.99 1.01 2.1 1.73 2.07.7-.03.97-.45 1.82-.45.85 0 1.09.45 1.83.44.75-.01 1.22-1 1.68-2 .52-1.14.73-2.25.74-2.31-.02-.01-1.36-.52-1.37-2.08z" />
                </svg>
                <span
                  css={css`
                    color: white;
                    font-size: 10px;
                    font-weight: 500;
                  `}
                >
                  Pay
                </span>
              </div>
              <span
                css={css`
                  font-weight: 400;
                  font-size: 14px;
                  color: #10100f;
                `}
              >
                Apple Pay
              </span>
            </div>
            <div
              css={css`
                height: 1px;
                background: rgba(58, 58, 44, 0.08);
              `}
            />
            <div
              css={css`
                padding: 10px 16px;
                display: flex;
                align-items: center;
                gap: 10px;
              `}
            >
              <div
                css={css`
                  width: 16px;
                  height: 16px;
                  border-radius: 50%;
                  border: 1px solid rgba(58, 58, 44, 0.25);
                  flex-shrink: 0;
                `}
              />
              <div
                css={css`
                  border: 1px solid rgba(58, 58, 44, 0.18);
                  border-radius: 4px;
                  padding: 0 6px;
                  height: 20px;
                  display: flex;
                  align-items: center;
                `}
              >
                <span
                  css={css`
                    font-size: 11px;
                    font-weight: 500;
                    color: #4285f4;
                  `}
                >
                  G
                </span>
                <span
                  css={css`
                    font-size: 11px;
                    font-weight: 500;
                    color: #ea4335;
                  `}
                >
                  o
                </span>
                <span
                  css={css`
                    font-size: 11px;
                    font-weight: 500;
                    color: #fbbc05;
                  `}
                >
                  o
                </span>
                <span
                  css={css`
                    font-size: 11px;
                    font-weight: 500;
                    color: #34a853;
                  `}
                >
                  g
                </span>
                <span
                  css={css`
                    font-size: 11px;
                    font-weight: 500;
                    color: #4285f4;
                  `}
                >
                  l
                </span>
                <span
                  css={css`
                    font-size: 11px;
                    font-weight: 500;
                    color: #ea4335;
                  `}
                >
                  e
                </span>
                <span
                  css={css`
                    font-size: 11px;
                    font-weight: 500;
                    color: #10100f;
                    margin-left: 4px;
                  `}
                >
                  Pay
                </span>
              </div>
              <span
                css={css`
                  font-weight: 400;
                  font-size: 14px;
                  color: #10100f;
                `}
              >
                Google Pay
              </span>
            </div>
          </div>
        </>
      )}
      <button
        type="button"
        css={css`
          width: 100%;
          background: #10100f;
          color: white;
          border-radius: 50px;
          height: 52px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 500;
          font-size: 15px;
          letter-spacing: 0.01em;
          font-family: inherit;
          cursor: pointer;
        `}
      >
        {buttonLabel}
      </button>
      <p
        css={css`
          text-align: center;
          font-weight: 400;
          font-size: 13px;
          color: rgba(16, 16, 15, 0.4);
        `}
      >
        100% secure payments by{' '}
        <span
          css={css`
            font-weight: 500;
            color: rgba(16, 16, 15, 0.55);
          `}
        >
          Stripe
        </span>
      </p>
      {hasTestimonial && (
        <>
          <div
            css={css`
              height: 1px;
              background: rgba(0, 0, 0, 0.07);
              margin: 4px 0;
            `}
          />
          <div
            css={css`
              display: flex;
              flex-direction: column;
              align-items: center;
              gap: 14px;
              padding-bottom: 8px;
            `}
          >
            <div
              css={css`
                width: 56px;
                height: 56px;
                border-radius: 50%;
                background: #e4e4e0;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-shrink: 0;
              `}
            >
              <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
                <circle cx="14" cy="10" r="5" fill="rgba(16,16,15,0.22)" />
                <path d="M3 27c0-6.075 4.925-11 11-11s11 4.925 11 11" fill="rgba(16,16,15,0.22)" />
              </svg>
            </div>
            {testimonialText && (
              <p
                css={css`
                  font-weight: 400;
                  font-size: 14px;
                  color: #10100f;
                  text-align: center;
                  font-style: italic;
                  line-height: 1.6;
                  max-width: 360px;
                `}
              >
                &ldquo;{testimonialText}&rdquo;
              </p>
            )}
            {testimonialName && (
              <p
                css={css`
                  font-weight: 500;
                  font-size: 13px;
                  color: rgba(16, 16, 15, 0.6);
                  text-align: center;
                `}
              >
                {testimonialName}
              </p>
            )}
          </div>
        </>
      )}
    </div>
  );

  if (isMobile) {
    return (
      <div
        css={css`
          display: flex;
          flex-direction: column;
          height: 100%;
          overflow-y: auto;
          scrollbar-width: none;
          &::-webkit-scrollbar {
            display: none;
          }
          background: white;
        `}
      >
        {orderSummary}
        {formSection}
      </div>
    );
  }
  return (
    <div
      css={css`
        display: flex;
        min-height: 100%;
      `}
    >
      {formSection}
      <div
        css={css`
          width: 1px;
          background: rgba(0, 0, 0, 0.07);
          flex-shrink: 0;
        `}
      />
      {orderSummary}
    </div>
  );
}

// ─── Main page ────────────────────────────────────────────────────────────────
export default function NewProductPage() {
  const [productName, setProductName] = useState('');
  const [productDescription, setProductDescription] = useState('');
  const [productImage, setProductImage] = useState<string | null>(null);
  const [productPrice, setProductPrice] = useState('');
  const [productSalesPrice, setProductSalesPrice] = useState('');
  const [paymentType, setPaymentType] = useState('one-time');
  const [deliveryType, setDeliveryType] = useState('delivery-page');
  const [deliveryUrl, setDeliveryUrl] = useState('');
  const [hasBumpOffer, setHasBumpOffer] = useState(false);
  const [bumpOfferTitle, setBumpOfferTitle] = useState('');
  const [testimonialName, setTestimonialName] = useState('');
  const [testimonialText, setTestimonialText] = useState('');
  const [testimonialEnabled, setTestimonialEnabled] = useState(false);
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [previewTab, setPreviewTab] = useState('desktop');

  const hasNameAndDesc = productName.trim().length > 0 && productDescription.trim().length > 0;
  const hasTestimonial =
    testimonialEnabled && (testimonialName.trim().length > 0 || testimonialText.trim().length > 0);
  function getPhase() {
    if (hasTestimonial) return 4;
    if (hasBumpOffer) return 3;
    if (productImage) return 2;
    if (hasNameAndDesc) return 1;
    return 0;
  }
  const phase = getPhase();
  const isFree = productPrice !== '' && Number(productPrice) === 0;
  const isOneTime = paymentType === 'one-time';
  const isRecurring = paymentType === 'recurring';
  const isRedirectUrl = deliveryType === 'redirect-url';

  return (
    <div
      css={[
        pageReset,
        css`
          background: #f9f9f6;
          min-height: 100vh;
          font-family: 'Flodesk Sans', sans-serif;
        `,
      ]}
    >
      {/* Top Nav */}
      <div
        css={css`
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          z-index: 50;
          background: white;
          border-bottom: 1px solid rgba(55, 55, 52, 0.12);
          height: 64px;
          overflow: clip;
        `}
      >
        <div
          css={css`
            position: absolute;
            border: 1px solid rgba(61, 46, 41, 0.31);
            display: flex;
            gap: 12px;
            height: 40px;
            align-items: center;
            justify-content: center;
            left: 20px;
            padding: 0 17px;
            border-radius: 6px;
            top: 12px;
            cursor: pointer;
          `}
        >
          <p
            css={css`
              font-weight: 500;
              line-height: 20px;
              font-size: 14px;
              color: #241a17;
              white-space: nowrap;
            `}
          >
            Cancel
          </p>
        </div>
        <div
          css={css`
            transform: translateX(-50%);
            position: absolute;
            display: flex;
            gap: 16px;
            height: 64px;
            align-items: center;
            left: calc(50% + 0.47px);
            top: 0;
          `}
        >
          <div
            css={css`
              display: flex;
              height: 100%;
              align-items: center;
              justify-content: center;
              flex-shrink: 0;
            `}
          >
            <p
              css={css`
                font-weight: 500;
                line-height: 20px;
                font-size: 14px;
                color: #241a17;
                white-space: nowrap;
              `}
            >
              Product{' '}
            </p>
          </div>
          {!isRedirectUrl && (
            <>
              <div
                css={css`
                  display: flex;
                  height: 14px;
                  align-items: center;
                  justify-content: center;
                  flex-shrink: 0;
                `}
              >
                <div
                  css={css`
                    height: 7.778px;
                    position: relative;
                    flex-shrink: 0;
                    width: 4.472px;
                  `}
                >
                  <img
                    alt=""
                    css={css`
                      display: block;
                      max-width: none;
                      width: 100%;
                      height: 100%;
                    `}
                    src={imgShape3}
                  />
                </div>
              </div>
              <div
                css={css`
                  display: flex;
                  height: 100%;
                  align-items: center;
                  justify-content: center;
                  flex-shrink: 0;
                `}
              >
                <p
                  css={css`
                    font-weight: 500;
                    line-height: 20px;
                    font-size: 14px;
                    color: rgba(61, 46, 41, 0.52);
                    white-space: nowrap;
                  `}
                >
                  Delivery
                </p>
              </div>
            </>
          )}
        </div>
        <div
          css={css`
            position: absolute;
            display: flex;
            gap: 0;
            height: 56px;
            align-items: center;
            justify-content: flex-end;
            right: 20px;
            top: 4px;
          `}
        >
          <div
            css={css`
              background: #241a17;
              border: 1px solid rgba(0, 0, 0, 0);
              display: flex;
              gap: 12px;
              height: 40px;
              align-items: center;
              justify-content: center;
              padding: 0 17px;
              position: relative;
              border-radius: 6px;
              flex-shrink: 0;
              cursor: pointer;
            `}
          >
            <p
              css={css`
                font-weight: 500;
                line-height: 20px;
                font-size: 14px;
                color: #f9f8f8;
                white-space: nowrap;
              `}
            >
              {isRedirectUrl ? 'Finish product' : 'Go to last step'}
            </p>
          </div>
        </div>
      </div>

      {/* Main layout */}
      <div
        css={css`
          display: flex;
          padding-top: 64px;
          min-height: 100vh;
        `}
      >
        {/* Left: scrollable form */}
        <div
          css={css`
            overflow-y: auto;
            flex: 1;
            scrollbar-width: none;
            &::-webkit-scrollbar {
              display: none;
            }
            max-height: calc(100vh - 64px);
          `}
        >
          <div
            css={css`
              display: flex;
              flex-direction: column;
              gap: 8px;
              align-items: center;
              padding: 40px 0;
            `}
          >
            {/* Product details */}
            <div
              css={css`
                background: white;
                display: flex;
                align-items: flex-start;
                overflow-x: clip;
                padding: 40px 64px;
                position: relative;
                border-radius: 16px;
                flex-shrink: 0;
              `}
            >
              <div
                css={css`
                  display: flex;
                  flex-direction: column;
                  gap: 24px;
                  align-items: flex-start;
                  position: relative;
                  flex-shrink: 0;
                `}
              >
                <p
                  css={css`
                    font-weight: 500;
                    font-size: 24px;
                    line-height: 28.627px;
                    color: #241a17;
                    white-space: nowrap;
                  `}
                >
                  Product details
                </p>
                <label
                  css={css`
                    display: flex;
                    flex-direction: column;
                    gap: 8px;
                    align-items: flex-start;
                    position: relative;
                    flex-shrink: 0;
                    width: 500px;
                  `}
                >
                  <p
                    css={css`
                      font-weight: 500;
                      line-height: 20px;
                      font-size: 14px;
                      color: #10100f;
                    `}
                  >
                    Product name
                  </p>
                  <input
                    type="text"
                    placeholder="Product name"
                    value={productName}
                    onChange={e => setProductName(e.target.value)}
                    css={css`
                      border: 1px solid rgba(58, 58, 44, 0.23);
                      font-weight: 400;
                      height: 48px;
                      padding: 0 18px;
                      border-radius: 6px;
                      font-size: 14px;
                      color: #10100f;
                      width: 100%;
                      background: white;
                      outline: none;
                      font-family: inherit;
                      &:focus {
                        border-color: #241a17;
                      }
                      &::placeholder {
                        color: #88887c;
                      }
                    `}
                  />
                </label>
                <div
                  css={css`
                    display: flex;
                    gap: 16px;
                    align-items: flex-start;
                    position: relative;
                    flex-shrink: 0;
                    width: 100%;
                  `}
                >
                  <label
                    css={css`
                      display: flex;
                      flex-direction: column;
                      gap: 8px;
                      align-items: flex-start;
                      position: relative;
                      flex-shrink: 0;
                      width: 242px;
                    `}
                  >
                    <p
                      css={css`
                        font-weight: 500;
                        line-height: 20px;
                        font-size: 14px;
                        color: #10100f;
                      `}
                    >
                      Description
                    </p>
                    <textarea
                      placeholder="Describe your product in detail"
                      value={productDescription}
                      onChange={e => setProductDescription(e.target.value)}
                      css={css`
                        border: 1px solid rgba(58, 58, 44, 0.23);
                        font-weight: 400;
                        height: 242px;
                        padding: 8px 12px;
                        border-radius: 6px;
                        font-size: 14px;
                        color: #10100f;
                        width: 100%;
                        background: white;
                        outline: none;
                        font-family: inherit;
                        resize: none;
                        &:focus {
                          border-color: #241a17;
                        }
                        &::placeholder {
                          color: #88887c;
                        }
                      `}
                    />
                  </label>
                  <ImageUpload onImageChange={setProductImage} />
                </div>
                <div
                  css={css`
                    background: #f4f4f0;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    padding: 14px 16px;
                    position: relative;
                    border-radius: 10px;
                    flex-shrink: 0;
                    width: 100%;
                  `}
                >
                  <div
                    css={css`
                      position: relative;
                      flex-shrink: 0;
                      width: 468px;
                    `}
                  >
                    <div
                      css={css`
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        position: relative;
                        width: 100%;
                      `}
                    >
                      <div
                        css={css`
                          display: flex;
                          flex: 1 0 0;
                          align-items: center;
                          justify-content: space-between;
                          min-width: 0;
                          position: relative;
                        `}
                      >
                        <p
                          css={css`
                            flex: 1 0 0;
                            font-weight: 500;
                            line-height: 20px;
                            min-width: 0;
                            font-size: 14px;
                            color: #241a17;
                          `}
                        >
                          Physical product
                        </p>
                        <Switch label={false} />
                      </div>
                    </div>
                  </div>
                  <p
                    css={css`
                      font-weight: 400;
                      line-height: 20px;
                      min-width: 100%;
                      font-size: 14px;
                      color: rgba(61, 46, 41, 0.52);
                    `}
                  >
                    Need to send something physical? Add shipping fields to your checkout.
                  </p>
                </div>
              </div>
            </div>

            {/* Pricing */}
            <div
              css={css`
                background: white;
                display: flex;
                align-items: flex-start;
                overflow-x: clip;
                padding: 40px 64px;
                position: relative;
                border-radius: 16px;
                flex-shrink: 0;
              `}
            >
              <div
                css={css`
                  display: flex;
                  flex-direction: column;
                  gap: 24px;
                  align-items: flex-start;
                  position: relative;
                  flex-shrink: 0;
                `}
              >
                <p
                  css={css`
                    font-weight: 500;
                    font-size: 24px;
                    line-height: 28.627px;
                    color: #241a17;
                    white-space: nowrap;
                  `}
                >
                  Pricing
                </p>
                <div
                  css={css`
                    display: flex;
                    flex-direction: column;
                    gap: 16px;
                    align-items: flex-start;
                    position: relative;
                    flex-shrink: 0;
                    width: 500px;
                  `}
                >
                  <div
                    css={css`
                      background: #f4f4f0;
                      display: flex;
                      align-items: flex-start;
                      overflow: clip;
                      position: relative;
                      border-radius: 8px;
                      flex-shrink: 0;
                      width: 500px;
                    `}
                  >
                    <button
                      type="button"
                      onClick={() => setPaymentType('one-time')}
                      css={css`
                        display: flex;
                        flex: 1 0 0;
                        height: 40px;
                        align-items: center;
                        justify-content: center;
                        padding: 0 20px;
                        position: relative;
                        border-radius: 8px;
                        ${isOneTime
                          ? 'background:white;border:2px solid #f4f4f0;'
                          : ''}cursor:pointer;
                        font-family: inherit;
                      `}
                    >
                      <p
                        css={css`
                          font-weight: 500;
                          line-height: 20px;
                          font-size: 14px;
                          white-space: nowrap;
                          ${isOneTime ? 'color:#10100f;' : 'color:rgba(57,57,45,0.52);'}
                        `}
                      >
                        One-time payment
                      </p>
                    </button>
                    <button
                      type="button"
                      onClick={() => setPaymentType('recurring')}
                      css={css`
                        display: flex;
                        flex: 1 0 0;
                        height: 40px;
                        align-items: center;
                        justify-content: center;
                        padding: 0 20px;
                        position: relative;
                        border-radius: 8px;
                        ${isRecurring
                          ? 'background:white;border:2px solid #f4f4f0;'
                          : ''}cursor:pointer;
                        font-family: inherit;
                      `}
                    >
                      <p
                        css={css`
                          font-weight: 500;
                          line-height: 20px;
                          font-size: 14px;
                          white-space: nowrap;
                          ${isRecurring ? 'color:#10100f;' : 'color:rgba(57,57,45,0.52);'}
                        `}
                      >
                        Recurring payment
                      </p>
                    </button>
                  </div>
                  {isOneTime ? (
                    <>
                      <label
                        css={css`
                          display: flex;
                          flex-direction: column;
                          gap: 8px;
                          align-items: flex-start;
                          position: relative;
                          width: 500px;
                        `}
                      >
                        <p
                          css={css`
                            font-weight: 500;
                            line-height: 20px;
                            font-size: 14px;
                            color: #111110;
                          `}
                        >
                          Price
                        </p>
                        <div
                          css={css`
                            border: 1px solid rgba(58, 58, 44, 0.23);
                            display: flex;
                            height: 48px;
                            align-items: center;
                            border-radius: 6px;
                            flex-shrink: 0;
                            width: 100%;
                            overflow: hidden;
                            &:focus-within {
                              border-color: #241a17;
                            }
                          `}
                        >
                          <input
                            type="number"
                            placeholder="0.00"
                            onChange={e => setProductPrice(e.target.value)}
                            css={css`
                              flex: 1;
                              height: 100%;
                              padding: 0 18px;
                              background: transparent;
                              font-size: 14px;
                              color: #251b18;
                              outline: none;
                              font-family: inherit;
                              &::placeholder {
                                color: #88887c;
                              }
                            `}
                          />
                          <span
                            css={css`
                              padding: 0 12px;
                              color: rgba(61, 46, 41, 0.52);
                              white-space: nowrap;
                              flex-shrink: 0;
                              font-size: 14px;
                            `}
                          >
                            USD
                          </span>
                        </div>
                      </label>
                      <label
                        css={
                          isFree
                            ? css`
                                display: flex;
                                flex-direction: column;
                                gap: 8px;
                                align-items: flex-start;
                                position: relative;
                                flex-shrink: 0;
                                width: 500px;
                                opacity: 0.4;
                                pointer-events: none;
                              `
                            : css`
                                display: flex;
                                flex-direction: column;
                                gap: 8px;
                                align-items: flex-start;
                                position: relative;
                                flex-shrink: 0;
                                width: 500px;
                              `
                        }
                      >
                        <div
                          css={css`
                            display: flex;
                            flex-direction: column;
                            align-items: flex-start;
                          `}
                        >
                          <p
                            css={css`
                              font-weight: 500;
                              line-height: 20px;
                              font-size: 14px;
                              color: #10100f;
                            `}
                          >
                            Sales price
                          </p>
                          <p
                            css={css`
                              font-weight: 400;
                              line-height: 20px;
                              font-size: 14px;
                              color: rgba(61, 46, 41, 0.52);
                            `}
                          >
                            Keep this empty if you don&apos;t want to show a sales price
                          </p>
                        </div>
                        <div
                          css={css`
                            border: 1px solid rgba(58, 58, 44, 0.23);
                            display: flex;
                            height: 48px;
                            align-items: center;
                            border-radius: 6px;
                            flex-shrink: 0;
                            width: 100%;
                            overflow: hidden;
                            &:focus-within {
                              border-color: #241a17;
                            }
                          `}
                        >
                          <input
                            type="number"
                            placeholder="0.00"
                            value={productSalesPrice}
                            onChange={e => setProductSalesPrice(e.target.value)}
                            disabled={isFree}
                            css={css`
                              flex: 1;
                              height: 100%;
                              padding: 0 18px;
                              font-weight: 400;
                              font-size: 14px;
                              color: #10100f;
                              outline: none;
                              background: transparent;
                              font-family: inherit;
                              &::placeholder {
                                color: #88887c;
                              }
                            `}
                          />
                          <span
                            css={css`
                              padding: 0 12px;
                              font-weight: 400;
                              font-size: 14px;
                              color: rgba(61, 46, 41, 0.52);
                              white-space: nowrap;
                              flex-shrink: 0;
                            `}
                          >
                            USD
                          </span>
                        </div>
                      </label>
                      <PaymentPlan />
                    </>
                  ) : (
                    <>
                      <div
                        css={css`
                          background: #f4f4f0;
                          border-radius: 8px;
                          padding: 16px;
                          width: 500px;
                          display: flex;
                          flex-direction: column;
                          gap: 12px;
                        `}
                      >
                        <div
                          css={css`
                            display: flex;
                            align-items: center;
                            gap: 8px;
                          `}
                        >
                          <svg width="12" height="16" viewBox="0 0 12 16" fill="none">
                            <circle cx="3" cy="3" r="1.5" fill="rgba(58,58,44,0.4)" />
                            <circle cx="9" cy="3" r="1.5" fill="rgba(58,58,44,0.4)" />
                            <circle cx="3" cy="8" r="1.5" fill="rgba(58,58,44,0.4)" />
                            <circle cx="9" cy="8" r="1.5" fill="rgba(58,58,44,0.4)" />
                            <circle cx="3" cy="13" r="1.5" fill="rgba(58,58,44,0.4)" />
                            <circle cx="9" cy="13" r="1.5" fill="rgba(58,58,44,0.4)" />
                          </svg>
                          <p
                            css={css`
                              font-weight: 400;
                              line-height: 20px;
                              font-size: 14px;
                              color: #10100f;
                            `}
                          >
                            Edit subscription
                          </p>
                        </div>
                        <div
                          css={css`
                            border: 1px solid rgba(58, 58, 44, 0.23);
                            background: white;
                            display: flex;
                            height: 48px;
                            align-items: center;
                            border-radius: 6px;
                            width: 100%;
                            overflow: hidden;
                          `}
                        >
                          <span
                            css={css`
                              flex: 1;
                              padding: 0 18px;
                              font-weight: 400;
                              font-size: 14px;
                              color: #10100f;
                            `}
                          >
                            $39
                          </span>
                          <span
                            css={css`
                              padding: 0 12px;
                              font-weight: 400;
                              font-size: 14px;
                              color: rgba(61, 46, 41, 0.52);
                              white-space: nowrap;
                              flex-shrink: 0;
                            `}
                          >
                            USD
                          </span>
                        </div>
                        <div
                          css={css`
                            border: 1px solid rgba(58, 58, 44, 0.23);
                            background: white;
                            display: flex;
                            height: 48px;
                            align-items: center;
                            border-radius: 6px;
                            width: 100%;
                            overflow: hidden;
                            padding: 0 18px;
                          `}
                        >
                          <span
                            css={css`
                              flex: 1;
                              font-weight: 400;
                              font-size: 14px;
                              color: #10100f;
                            `}
                          >
                            Monthly
                          </span>
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path
                              d="M4 6L8 10L12 6"
                              stroke="rgba(58,58,44,0.5)"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                      </div>
                      <div
                        css={css`
                          display: flex;
                          justify-content: flex-end;
                          width: 500px;
                        `}
                      >
                        <button
                          type="button"
                          css={css`
                            border: 1px solid rgba(58, 58, 44, 0.23);
                            background: white;
                            display: flex;
                            height: 40px;
                            align-items: center;
                            justify-content: center;
                            gap: 8px;
                            padding: 0 20px;
                            border-radius: 8px;
                            cursor: pointer;
                            font-family: inherit;
                          `}
                        >
                          <span
                            css={css`
                              font-weight: 500;
                              font-size: 14px;
                              color: #10100f;
                            `}
                          >
                            + Add another
                          </span>
                        </button>
                      </div>
                    </>
                  )}
                  <div
                    css={css`
                      height: 0;
                      position: relative;
                      flex-shrink: 0;
                      width: 100%;
                    `}
                  >
                    <div
                      css={css`
                        position: absolute;
                        inset: -0.5px 0;
                      `}
                    >
                      <img
                        alt=""
                        css={css`
                          display: block;
                          max-width: none;
                          width: 100%;
                          height: 100%;
                        `}
                        src={imgSeparator}
                      />
                    </div>
                  </div>
                  <SalesTaxContent />
                </div>
              </div>
            </div>

            {/* Product limits */}
            <div
              css={css`
                background: white;
                display: flex;
                align-items: flex-start;
                overflow-x: clip;
                padding: 40px 64px;
                position: relative;
                border-radius: 16px;
                flex-shrink: 0;
              `}
            >
              <div
                css={css`
                  display: flex;
                  flex-direction: column;
                  gap: 24px;
                  align-items: flex-start;
                  position: relative;
                  flex-shrink: 0;
                  width: 500px;
                `}
              >
                <p
                  css={css`
                    font-weight: 500;
                    font-size: 24px;
                    line-height: 28.627px;
                    color: #241a17;
                    white-space: nowrap;
                  `}
                >
                  Product limits
                </p>
                <div
                  css={css`
                    display: flex;
                    flex-direction: column;
                    gap: 16px;
                    align-items: flex-start;
                    position: relative;
                    flex-shrink: 0;
                  `}
                >
                  <InventorySection />
                  <CheckoutExpiry />
                  <WaitlistContainer />
                </div>
              </div>
            </div>

            {/* Bump offer */}
            <div
              css={css`
                background: white;
                display: flex;
                align-items: flex-start;
                overflow-x: clip;
                padding: 40px 64px;
                position: relative;
                border-radius: 16px;
                flex-shrink: 0;
              `}
            >
              <div
                css={css`
                  display: flex;
                  flex-direction: column;
                  gap: 24px;
                  align-items: flex-start;
                  justify-content: center;
                  position: relative;
                  flex-shrink: 0;
                  width: 500px;
                `}
              >
                <p
                  css={css`
                    font-weight: 500;
                    font-size: 24px;
                    line-height: 28.627px;
                    color: #241a17;
                    white-space: nowrap;
                  `}
                >
                  Bump offer
                </p>
                <Component3
                  onBumpSelect={setHasBumpOffer}
                  bumpOfferTitle={bumpOfferTitle}
                  onBumpTitleChange={setBumpOfferTitle}
                  hasBumpOffer={hasBumpOffer}
                />
              </div>
            </div>

            {/* Testimonial */}
            <div
              css={css`
                background: white;
                display: flex;
                align-items: flex-start;
                overflow-x: clip;
                padding: 40px 64px;
                position: relative;
                border-radius: 16px;
                flex-shrink: 0;
              `}
            >
              <div
                css={css`
                  display: flex;
                  flex-direction: column;
                  gap: 24px;
                  align-items: flex-start;
                  justify-content: center;
                  position: relative;
                  flex-shrink: 0;
                  width: 500px;
                `}
              >
                <p
                  css={css`
                    font-weight: 500;
                    font-size: 24px;
                    line-height: 28.627px;
                    color: #241a17;
                    white-space: nowrap;
                  `}
                >
                  Testimonial
                </p>
                <Textfield
                  customerName={testimonialName}
                  onNameChange={setTestimonialName}
                  testimonialText={testimonialText}
                  onTextChange={setTestimonialText}
                  enabled={testimonialEnabled}
                  onToggle={setTestimonialEnabled}
                />
              </div>
            </div>

            {/* Delivery */}
            <div
              css={css`
                background: white;
                display: flex;
                align-items: flex-start;
                overflow-x: clip;
                padding: 40px 64px;
                position: relative;
                border-radius: 16px;
                flex-shrink: 0;
              `}
            >
              <div
                css={css`
                  display: flex;
                  flex-direction: column;
                  gap: 24px;
                  align-items: flex-start;
                  position: relative;
                  flex-shrink: 0;
                  width: 500px;
                `}
              >
                <p
                  css={css`
                    font-weight: 500;
                    font-size: 24px;
                    line-height: 28.627px;
                    color: #241a17;
                    white-space: nowrap;
                  `}
                >
                  Delivery
                </p>
                <div
                  css={css`
                    display: flex;
                    flex-direction: column;
                    gap: 24px;
                    align-items: flex-start;
                    position: relative;
                    flex-shrink: 0;
                    width: 500px;
                  `}
                >
                  <Component2 deliveryType={deliveryType} onToggle={setDeliveryType} />
                  {isRedirectUrl && (
                    <div
                      css={css`
                        display: flex;
                        flex-direction: column;
                        gap: 8px;
                        align-items: flex-start;
                        position: relative;
                        flex-shrink: 0;
                        width: 100%;
                      `}
                    >
                      <div
                        css={css`
                          display: flex;
                          flex-direction: column;
                          gap: 4px;
                        `}
                      >
                        <p
                          css={css`
                            font-weight: 500;
                            line-height: 20px;
                            font-size: 14px;
                            color: #241a17;
                          `}
                        >
                          Link to URL
                        </p>
                        <p
                          css={css`
                            font-weight: 400;
                            line-height: 20px;
                            font-size: 14px;
                            color: rgba(61, 46, 41, 0.52);
                          `}
                        >
                          Your buyer will receive an email with their receipt after purchase
                        </p>
                      </div>
                      <div
                        css={css`
                          border: 1px solid rgba(58, 58, 44, 0.23);
                          display: flex;
                          height: 48px;
                          align-items: center;
                          border-radius: 6px;
                          width: 100%;
                          overflow: hidden;
                          &:focus-within {
                            border-color: #241a17;
                          }
                        `}
                      >
                        <input
                          type="url"
                          placeholder="https://"
                          value={deliveryUrl}
                          onChange={e => setDeliveryUrl(e.target.value)}
                          css={css`
                            flex: 1;
                            height: 100%;
                            padding: 0 12px;
                            font-weight: 400;
                            font-size: 14px;
                            color: #10100f;
                            outline: none;
                            background: transparent;
                            font-family: inherit;
                            &::placeholder {
                              color: rgba(61, 46, 41, 0.52);
                            }
                          `}
                        />
                      </div>
                    </div>
                  )}
                  <div
                    css={css`
                      display: flex;
                      flex-direction: column;
                      gap: 8px;
                      align-items: flex-start;
                      position: relative;
                      flex-shrink: 0;
                      width: 100%;
                    `}
                  >
                    <div
                      css={css`
                        display: flex;
                        flex-direction: column;
                        gap: 4px;
                        align-items: flex-start;
                        position: relative;
                        flex-shrink: 0;
                        width: 100%;
                      `}
                    >
                      <p
                        css={css`
                          font-weight: 400;
                          line-height: 20px;
                          font-size: 14px;
                          color: #241a17;
                          white-space: nowrap;
                        `}
                      >
                        Track with Meta Pixel ID
                      </p>
                      <p
                        css={css`
                          font-weight: 400;
                          line-height: 17.8px;
                          font-size: 12px;
                          color: rgba(61, 46, 41, 0.52);
                        `}
                      >
                        Connect your Meta Pixel to track visitor actions and ad performance.{' '}
                        <span
                          css={css`
                            text-decoration: underline;
                          `}
                        >
                          Learn more
                        </span>
                      </p>
                    </div>
                    <div
                      css={css`
                        background: #f9f9f6;
                        border: 1px solid rgba(58, 58, 44, 0.23);
                        display: flex;
                        font-weight: 400;
                        gap: 8px;
                        height: 48px;
                        align-items: center;
                        padding: 0 12px;
                        position: relative;
                        border-radius: 6px;
                        flex-shrink: 0;
                        font-size: 14px;
                        white-space: nowrap;
                        width: 100%;
                      `}
                    >
                      <p
                        css={css`
                          overflow: hidden;
                          position: relative;
                          flex-shrink: 0;
                          color: rgba(57, 57, 45, 0.52);
                          width: 387px;
                        `}
                      >
                        545665848354
                      </p>
                      <p
                        css={css`
                          flex: 1 0 0;
                          height: 20px;
                          min-width: 0;
                          overflow: hidden;
                          position: relative;
                          color: #251b18;
                          text-align: right;
                        `}
                      >
                        Edit
                      </p>
                    </div>
                  </div>
                  <div
                    css={css`
                      display: flex;
                      flex-direction: column;
                      gap: 8px;
                      align-items: flex-start;
                      justify-content: center;
                      position: relative;
                      border-radius: 3px;
                      flex-shrink: 0;
                      width: 100%;
                    `}
                  >
                    <p
                      css={css`
                        font-weight: 400;
                        line-height: 20px;
                        font-size: 14px;
                        color: #241a17;
                      `}
                    >
                      Edit checkout link
                    </p>
                    <div
                      css={css`
                        display: flex;
                        align-items: center;
                        position: relative;
                        flex-shrink: 0;
                        width: 100%;
                      `}
                    >
                      <div
                        css={css`
                          background: #f9f9f6;
                          border: 1px solid rgba(58, 58, 44, 0.23);
                          display: flex;
                          flex: 1 0 0;
                          font-weight: 400;
                          gap: 8px;
                          height: 48px;
                          align-items: center;
                          min-width: 0;
                          padding: 0 12px;
                          position: relative;
                          border-radius: 6px;
                          font-size: 14px;
                          white-space: nowrap;
                        `}
                      >
                        <p
                          css={css`
                            position: relative;
                            flex-shrink: 0;
                            color: rgba(61, 46, 41, 0.52);
                          `}
                        >
                          sjoerd.myflodesk.com /
                        </p>
                        <p
                          css={css`
                            overflow: hidden;
                            position: relative;
                            flex-shrink: 0;
                            color: #10100f;
                            text-overflow: ellipsis;
                          `}
                        >
                          pho83h1d2y
                        </p>
                        <p
                          css={css`
                            flex: 1 0 0;
                            height: 20px;
                            min-width: 0;
                            overflow: hidden;
                            position: relative;
                            color: #251b18;
                            text-overflow: ellipsis;
                            text-align: right;
                          `}
                        >
                          Edit
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Right: animated preview panel */}
        <div
          css={css`
            width: 680px;
            flex-shrink: 0;
            position: sticky;
            top: 64px;
            height: calc(100vh - 64px);
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 26px;
            position: relative;
            overflow: clip;
            transform: translateX(-80px);
          `}
        >
          {/* Phase 0: floating cards */}
          <motion.div
            css={css`
              position: absolute;
              inset: 0;
              display: flex;
              align-items: center;
              justify-content: center;
            `}
            animate={{ y: phase === 0 ? '0%' : '-55%', opacity: phase === 0 ? 1 : 0 }}
            transition={{ type: 'spring', stiffness: 80, damping: 20, mass: 1, duration: 0.6 }}
            style={{ pointerEvents: phase === 0 ? 'auto' : 'none' }}
          >
            <Component4 />
          </motion.div>

          {/* Phase 1–3: product card */}
          <motion.div
            css={css`
              position: absolute;
              inset: 26px;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              gap: 12px;
            `}
            initial={{ y: '150%', rotate: 6.5 }}
            animate={{
              y: (() => {
                if (phase === 4) return '-55%';
                if (phase >= 1) return '0%';
                return '150%';
              })(),
              rotate: phase >= 1 ? 0 : 6.5,
              opacity: phase === 4 ? 0 : 1,
            }}
            transition={{ type: 'spring', stiffness: 80, damping: 20, mass: 1 }}
            style={{ pointerEvents: phase >= 1 && phase < 4 ? 'auto' : 'none' }}
          >
            <motion.div
              layout
              transition={{ type: 'spring', stiffness: 160, damping: 28, mass: 1 }}
              css={css`
                background: white;
                border: 1px solid rgba(55, 55, 52, 0.12);
                border-radius: 10px;
                box-shadow:
                  0px 5.881px 14.045px 0px rgba(0, 0, 0, 0.09),
                  0px 1.98px 3.06px 0px rgba(0, 0, 0, 0.05),
                  0px 1px 1px 0px rgba(0, 0, 0, 0.05);
                width: 320px;
                overflow: hidden;
              `}
            >
              <div
                css={css`
                  display: flex;
                  padding: 24px;
                  gap: 16px;
                  ${phase === 3
                    ? 'flex-direction:row;align-items:flex-start;'
                    : 'flex-direction:column;'}
                `}
              >
                <motion.div
                  layout
                  animate={{ width: phase === 3 ? 76 : 272, height: phase === 3 ? 76 : 272 }}
                  transition={{ type: 'spring', stiffness: 160, damping: 28, mass: 1 }}
                  css={css`
                    position: relative;
                    border-radius: 6px;
                    background: #f4f4f0;
                    overflow: hidden;
                    flex-shrink: 0;
                  `}
                >
                  <div
                    css={css`
                      position: absolute;
                      inset: 0;
                      transition: opacity 0.5s ease-in-out;
                      opacity: ${phase >= 2 ? 1 : 0};
                    `}
                  >
                    {productImage && (
                      <img
                        src={productImage}
                        alt="Product"
                        css={css`
                          position: absolute;
                          inset: 0;
                          width: 100%;
                          height: 100%;
                          object-fit: cover;
                          border-radius: 6px;
                        `}
                      />
                    )}
                  </div>
                </motion.div>
                <motion.div
                  layout
                  css={css`
                    display: flex;
                    flex-direction: column;
                    gap: 8px;
                    flex: 1;
                    min-width: 0;
                  `}
                >
                  <p
                    css={css`
                      font-weight: 500;
                      line-height: 24px;
                      font-size: 16px;
                      color: #10100f;
                    `}
                  >
                    {productName}
                  </p>
                  <AnimatePresence>
                    {phase < 3 && (
                      <motion.p
                        key="description"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.1 }}
                        css={css`
                          font-weight: 400;
                          line-height: 20px;
                          font-size: 14px;
                          color: #10100f;
                        `}
                      >
                        {productDescription}
                      </motion.p>
                    )}
                  </AnimatePresence>
                  <motion.div
                    layout
                    css={css`
                      display: flex;
                      align-items: flex-start;
                      justify-content: space-between;
                      width: 100%;
                    `}
                  >
                    <p
                      css={css`
                        font-weight: 400;
                        line-height: 20px;
                        font-size: 14px;
                        color: rgba(57, 57, 45, 0.52);
                        text-decoration: underline;
                        cursor: pointer;
                      `}
                    >
                      {phase === 3 ? 'See more' : 'See less'}
                    </p>
                    {(productPrice || isRecurring) && (
                      <div
                        css={css`
                          display: flex;
                          align-items: baseline;
                          gap: 6px;
                        `}
                      >
                        {(() => {
                          if (isRecurring)
                            return (
                              <p
                                css={css`
                                  font-weight: 500;
                                  line-height: 23.2px;
                                  font-size: 18px;
                                  color: #10100f;
                                `}
                              >
                                $39/mo
                              </p>
                            );
                          if (isFree)
                            return (
                              <p
                                css={css`
                                  font-weight: 500;
                                  line-height: 23.2px;
                                  font-size: 18px;
                                  color: #10100f;
                                `}
                              >
                                FREE
                              </p>
                            );
                          if (productSalesPrice)
                            return (
                              <>
                                <p
                                  css={css`
                                    font-weight: 500;
                                    line-height: 23.2px;
                                    font-size: 18px;
                                    color: #d33003;
                                  `}
                                >
                                  ${productSalesPrice}
                                </p>
                                <p
                                  css={css`
                                    font-weight: 400;
                                    font-size: 12px;
                                    color: #10100f;
                                    text-decoration: line-through;
                                  `}
                                >
                                  ${productPrice}
                                </p>
                              </>
                            );
                          return (
                            <p
                              css={css`
                                font-weight: 500;
                                line-height: 23.2px;
                                font-size: 18px;
                                color: #10100f;
                              `}
                            >
                              ${productPrice}
                            </p>
                          );
                        })()}
                      </div>
                    )}
                  </motion.div>
                </motion.div>
              </div>
            </motion.div>

            {/* Bump offer card */}
            <AnimatePresence>
              {phase >= 3 && (
                <motion.div
                  key="bump-offer"
                  initial={{ y: '150%' }}
                  animate={{ y: '0%' }}
                  exit={{ y: '150%' }}
                  transition={{ type: 'spring', stiffness: 80, damping: 20, mass: 1 }}
                  css={css`
                    background: white;
                    border: 1px solid rgba(55, 55, 52, 0.12);
                    display: flex;
                    flex-direction: column;
                    gap: 16px;
                    align-items: flex-start;
                    padding: 24px;
                    border-radius: 10px;
                    box-shadow:
                      0px 5.881px 14.045px 0px rgba(0, 0, 0, 0.09),
                      0px 1.98px 3.06px 0px rgba(0, 0, 0, 0.05),
                      0px 1px 1px 0px rgba(0, 0, 0, 0.05);
                    width: 320px;
                  `}
                >
                  <div
                    css={css`
                      display: flex;
                      align-items: flex-start;
                      justify-content: space-between;
                      width: 100%;
                    `}
                  >
                    <p
                      css={css`
                        font-weight: 500;
                        line-height: 24px;
                        font-size: 16px;
                        color: #10100f;
                        flex: 1;
                      `}
                    >
                      {bumpOfferTitle || 'Offer title'}
                    </p>
                    <p
                      css={css`
                        font-weight: 500;
                        line-height: 23.2px;
                        font-size: 18px;
                        color: #10100f;
                      `}
                    >
                      $20
                    </p>
                  </div>
                  <div
                    css={css`
                      position: relative;
                      border-radius: 6px;
                      flex-shrink: 0;
                      width: 100%;
                      height: 272px;
                      overflow: hidden;
                    `}
                  >
                    <img
                      src={imgBumpOffer}
                      alt=""
                      css={css`
                        position: absolute;
                        inset: 0;
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        border-radius: 6px;
                      `}
                    />
                  </div>
                  <div
                    css={css`
                      display: flex;
                      flex-direction: column;
                      gap: 8px;
                      width: 100%;
                    `}
                  >
                    <p
                      css={css`
                        font-weight: 500;
                        line-height: 20px;
                        font-size: 14px;
                        color: #10100f;
                      `}
                    >
                      30 EXTRA MINUTES to chat about your trip
                    </p>
                    <p
                      css={css`
                        font-weight: 400;
                        line-height: 20px;
                        font-size: 14px;
                        color: #10100f;
                      `}
                    >
                      If you&apos;re feeling like you have a lot of questions (or a really long
                      trip) and you&apos;d like to book more time, don&apos;t worry I ...
                    </p>
                    <p
                      css={css`
                        font-weight: 400;
                        line-height: 20px;
                        font-size: 14px;
                        color: #10100f;
                        text-decoration: underline;
                        cursor: pointer;
                      `}
                    >
                      See more
                    </p>
                  </div>
                  <div
                    css={css`
                      background: #f4f4f0;
                      display: flex;
                      gap: 12px;
                      height: 40px;
                      align-items: center;
                      justify-content: center;
                      padding: 0 16px;
                      border-radius: 6px;
                      width: 100%;
                      cursor: pointer;
                    `}
                  >
                    <p
                      css={css`
                        font-weight: 500;
                        line-height: 20px;
                        font-size: 14px;
                        color: #10100f;
                      `}
                    >
                      Add to order
                    </p>
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
          </motion.div>

          {/* Phase 4: testimonial */}
          <motion.div
            css={css`
              position: absolute;
              inset: 26px;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              gap: 16px;
            `}
            initial={{ y: '150%' }}
            animate={{ y: phase === 4 ? '0%' : '150%' }}
            transition={{ type: 'spring', stiffness: 80, damping: 20, mass: 1 }}
            style={{ pointerEvents: phase === 4 ? 'auto' : 'none' }}
          >
            <img
              src={imgProfilePic}
              alt=""
              css={css`
                width: 106px;
                height: 106px;
                border-radius: 50%;
                object-fit: cover;
                flex-shrink: 0;
              `}
            />
            <div
              css={css`
                display: flex;
                flex-direction: column;
                gap: 16px;
                align-items: center;
                text-align: center;
                width: 320px;
              `}
            >
              <p
                style={{ fontFamily: 'Georgia, serif' }}
                css={css`
                  font-size: 21px;
                  line-height: 1.25;
                  color: #10100f;
                `}
              >
                {testimonialText
                  ? `\u201c${testimonialText}\u201d`
                  : '\u201cMy inbox is full of new inquiries!\u201d'}
              </p>
              <p
                css={css`
                  font-weight: 400;
                  font-size: 18px;
                  line-height: 1.25;
                  color: #10100f;
                `}
              >
                {testimonialName || 'Customer name'}
              </p>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Preview button */}
      <button
        type="button"
        onClick={() => setShowPreviewModal(true)}
        css={css`
          position: fixed;
          bottom: 20px;
          right: 20px;
          z-index: 50;
          background: #10100f;
          display: flex;
          gap: 12px;
          height: 48px;
          align-items: center;
          justify-content: center;
          padding: 0 19px;
          border-radius: 8px;
          cursor: pointer;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
          transition: opacity 0.15s;
          &:hover {
            opacity: 0.8;
          }
        `}
      >
        <Icon />
        <p
          css={css`
            font-weight: 500;
            font-size: 14px;
            color: #f9f9f6;
            white-space: nowrap;
          `}
        >
          Preview
        </p>
      </button>

      {/* Preview modal */}
      <AnimatePresence>
        {showPreviewModal && (
          <motion.div
            css={css`
              position: fixed;
              inset: 0;
              z-index: 100;
              background: #f9f9f6;
              display: flex;
              flex-direction: column;
            `}
            initial={{ y: '100%' }}
            animate={{ y: 0 }}
            exit={{ y: '100%' }}
            transition={{ type: 'spring', stiffness: 300, damping: 35 }}
          >
            <div
              css={css`
                height: 64px;
                background: white;
                border-bottom: 1px solid rgba(55, 55, 52, 0.12);
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0 20px;
                flex-shrink: 0;
              `}
            >
              <button
                type="button"
                onClick={() => setShowPreviewModal(false)}
                css={css`
                  border: 1px solid rgba(61, 46, 41, 0.31);
                  display: flex;
                  align-items: center;
                  gap: 8px;
                  height: 40px;
                  padding: 0 17px;
                  border-radius: 6px;
                  font-size: 14px;
                  font-weight: 500;
                  color: #241a17;
                  cursor: pointer;
                  font-family: inherit;
                  transition: opacity 0.15s;
                  &:hover {
                    opacity: 0.6;
                  }
                `}
              >
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                  <path
                    d="M9 2L4 7l5 5"
                    stroke="currentColor"
                    strokeWidth="1.6"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                Back
              </button>
              <div
                css={css`
                  display: flex;
                  align-items: center;
                  gap: 16px;
                `}
              >
                <button
                  type="button"
                  aria-label="Desktop preview"
                  onClick={() => setPreviewTab('desktop')}
                  css={css`
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    transition: opacity 0.15s;
                    &:hover {
                      opacity: 0.6;
                    }
                  `}
                >
                  <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
                    <rect
                      x="1.5"
                      y="3"
                      width="19"
                      height="13"
                      rx="2"
                      stroke={previewTab === 'desktop' ? '#10100f' : 'rgba(36,26,23,0.3)'}
                      strokeWidth="1.6"
                    />
                    <path
                      d="M7.5 19h7M11 16v3"
                      stroke={previewTab === 'desktop' ? '#10100f' : 'rgba(36,26,23,0.3)'}
                      strokeWidth="1.6"
                      strokeLinecap="round"
                    />
                  </svg>
                </button>
                <button
                  type="button"
                  aria-label="Mobile preview"
                  onClick={() => setPreviewTab('mobile')}
                  css={css`
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    transition: opacity 0.15s;
                    &:hover {
                      opacity: 0.6;
                    }
                  `}
                >
                  <svg width="16" height="22" viewBox="0 0 16 22" fill="none">
                    <rect
                      x="1"
                      y="1"
                      width="14"
                      height="20"
                      rx="2.5"
                      stroke={previewTab === 'mobile' ? '#10100f' : 'rgba(36,26,23,0.3)'}
                      strokeWidth="1.6"
                    />
                    <circle
                      cx="8"
                      cy="17.5"
                      r="1"
                      fill={previewTab === 'mobile' ? '#10100f' : 'rgba(36,26,23,0.3)'}
                    />
                  </svg>
                </button>
              </div>
              <div
                css={css`
                  width: 80px;
                `}
              />
            </div>
            <div
              css={css`
                flex: 1;
                overflow: hidden;
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 24px 32px 32px;
              `}
            >
              <AnimatePresence exitBeforeEnter>
                {previewTab === 'desktop' && (
                  <motion.div
                    key="desktop"
                    css={css`
                      width: 100%;
                      max-width: 1100px;
                      display: flex;
                      flex-direction: column;
                      border-radius: 12px;
                      overflow: hidden;
                      border: 1px solid rgba(0, 0, 0, 0.07);
                      box-shadow: 0 12px 48px rgba(0, 0, 0, 0.14);
                    `}
                    style={{ height: 'calc(100vh - 160px)' }}
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: 10 }}
                    transition={{ duration: 0.18 }}
                  >
                    <div
                      css={css`
                        background: #e4e4e1;
                        display: flex;
                        align-items: center;
                        padding: 0 16px;
                        height: 42px;
                        gap: 8px;
                        flex-shrink: 0;
                      `}
                    >
                      <div
                        css={css`
                          display: flex;
                          gap: 6px;
                          align-items: center;
                        `}
                      >
                        <div
                          css={css`
                            width: 12px;
                            height: 12px;
                            border-radius: 50%;
                            background: #ff5f57;
                          `}
                        />
                        <div
                          css={css`
                            width: 12px;
                            height: 12px;
                            border-radius: 50%;
                            background: #febc2e;
                          `}
                        />
                        <div
                          css={css`
                            width: 12px;
                            height: 12px;
                            border-radius: 50%;
                            background: #28c840;
                          `}
                        />
                      </div>
                      <div
                        css={css`
                          flex: 1;
                          background: rgba(255, 255, 255, 0.5);
                          border-radius: 6px;
                          height: 26px;
                          margin: 0 12px;
                          border: 1px solid rgba(0, 0, 0, 0.06);
                        `}
                      />
                    </div>
                    <div
                      css={css`
                        flex: 1;
                        overflow-y: auto;
                        scrollbar-width: none;
                        &::-webkit-scrollbar {
                          display: none;
                        }
                      `}
                    >
                      <CheckoutPage
                        productName={productName}
                        productDescription={productDescription}
                        productImage={productImage}
                        productPrice={productPrice}
                        productSalesPrice={productSalesPrice}
                        isFree={isFree}
                        isRecurring={isRecurring}
                        hasBumpOffer={hasBumpOffer}
                        bumpOfferTitle={bumpOfferTitle}
                        testimonialName={testimonialName}
                        testimonialText={testimonialText}
                        hasTestimonial={hasTestimonial}
                        isMobile={false}
                      />
                    </div>
                  </motion.div>
                )}
                {previewTab === 'mobile' && (
                  <motion.div
                    key="mobile"
                    css={css`
                      display: flex;
                      flex-direction: column;
                      overflow: hidden;
                      flex-shrink: 0;
                    `}
                    style={{
                      width: 375,
                      height: 'calc(100vh - 160px)',
                      border: '10px solid #1c1c1e',
                      borderRadius: 48,
                      boxShadow:
                        '0 20px 60px rgba(0,0,0,0.22), inset 0 0 0 1px rgba(255,255,255,0.08)',
                    }}
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: 10 }}
                    transition={{ duration: 0.18 }}
                  >
                    <div
                      css={css`
                        background: #f9f9f6;
                        display: flex;
                        justify-content: center;
                        align-items: flex-start;
                        padding: 12px 0 4px;
                        flex-shrink: 0;
                      `}
                    >
                      <div
                        css={css`
                          width: 112px;
                          height: 22px;
                          background: #1c1c1e;
                          border-radius: 50%;
                        `}
                      />
                    </div>
                    <div
                      css={css`
                        flex: 1;
                        overflow-y: auto;
                        scrollbar-width: none;
                        &::-webkit-scrollbar {
                          display: none;
                        }
                      `}
                    >
                      <CheckoutPage
                        productName={productName}
                        productDescription={productDescription}
                        productImage={productImage}
                        productPrice={productPrice}
                        productSalesPrice={productSalesPrice}
                        isFree={isFree}
                        isRecurring={isRecurring}
                        hasBumpOffer={hasBumpOffer}
                        bumpOfferTitle={bumpOfferTitle}
                        testimonialName={testimonialName}
                        testimonialText={testimonialText}
                        hasTestimonial={hasTestimonial}
                        isMobile
                      />
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
